<!-- 邀请开卡 -->
<template>
  <div class="createPlayStep new-input-box">
    <!-- 头部返回 -->
    <div class="backBox">
      <jd-button
        type="blue"
        :styleTextObj="{
          width: '44px',
          height: '24px',
          'line-height': '24px',
          padding: '0 8px',
          'min-width': '44px',
        }"
        @click="returnBack()"
        >返回</jd-button
      >
      <span class="backBox_name">{{ activityData.name }}</span>
    </div>
    <div :class="{ formBox: localStep != 99 }">
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="localStep">
          <!-- <el-step title="活动模板"></el-step> -->
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>

      <!-- 选中活动模板 -->
      <div class="firststep" v-if="localStep == 99">
        <div class="activeEdit_bottom">
          <div class="template">
            <div style="width: 82px; padding-top: 5px">模板类型：</div>
            <div class="template-nav">
              <div
                class="template-wz pointer"
                v-for="(item, index) in tempSwitchList"
                :key="item.id"
                :class="{ activeTem: index == 0 }"
                v-show="item.isVisible"
              >
                {{ item.title }}
              </div>
            </div>
          </div>
          <!-- m模板图 -->
          <div class="templateBox">
            <!-- 定制 -->
            <div class="temImg">
              <div
                class="temImg_content"
                @click="handleOpen()"
                style="border: 1px solid #d4e2ff"
              >
                <div class="temImg_content_img temImg_dz">
                  <div class="temImg_dz_center">
                    <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/pages/dz.svg" alt="" />
                    <span>品牌定制</span>
                  </div>
                </div>
                <div
                  class="temImg_content_wz"
                  style="background: #eaf1ff"
                ></div>
              </div>
              <div
                class="temImg_content_bgshadow"
                style="height: 432px; border-radius: 8px"
                @click="handleOpen()"
              >
                <div class="temImg_content_bgshadow_codeDZ">
                  <img
                    style="width: 100%"
                    src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/wximg.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <!-- 模板 -->
            <div class="temImg">
              <div class="temImg_content">
                <div class="temImg_content_img">
                  <img
                    style="width: 100%; max-height: 380px"
                    :src="activityData.telImg"
                    alt=""
                  />
                </div>
                <div class="temImg_content_wz">
                  <span class="temImg_title">{{ activityData.name }}</span>
                  <span class="temImg_desc">模板ID：1</span>
                </div>
              </div>
              <!-- hover -->
              <div class="temImg_content_bgshadow">
                <div
                  class="temImg_content_bgshadow_code qrCodeIMG"
                  id="queryId"
                  ref="queryId"
                ></div>
                <div class="temImg_content_bgshadow_codeDesc">
                  手机扫码预览模板
                </div>
                <div
                  class="temImg_content_bgshadow_btn pointer"
                  @click="nextStep()"
                >
                  使用此模板
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--  活动条件表单部分 -->
      <div class="secondstep" v-if="localStep != 99">
        <el-form
          :model="ruleForm"
          :rules="rules"
          class="backgroundForm"
          ref="ruleForm"
          label-width="160px"
        >
          <informationForm 
            v-model="ruleForm"
            needNonMember
            :localStepNum="localStep"
            :defaultActivityStartTime.sync="ruleForm.activityStartTime"
            :defaultActivityEndTime.sync="ruleForm.activityEndTime"
            :defaultActMember.sync="actMember"
            :peopleSelected.sync="peopleSelected"
            :plusObject.sync="ruleDto.plusObject"
            :isCheckOpenCardTime.sync="ruleDto.isCheckOpenCardTime"
            :openCardStartTime.sync="ruleDto.openCardStartTime"
            :openCardEndTime.sync="ruleDto.openCardEndTime"
            :disabled="isStart"
            :isShowCondFollow="false"
            :isShowBlack="true"
            @selectPeopleSure="selectPeopleSure"
            :customerPaperwork="customerPaperwork"
            @handlCorwdTips="customerPaperwork = $event;$forceUpdate()"
          />
          <!-- <jd-title label="基本信息" type="bold"></jd-title>
          <el-form-item label="活动名称:" required>
            <el-input
              v-model="ruleForm.activityName"
              maxlength="15"
              show-word-limit
              placeholder="请填入活动名称"
              style="width: 400px"
              :disabled="isStart"
            ></el-input>
          </el-form-item>

          <el-form-item label="活动时间:" required>
            <div class="my_select_time">
              <el-date-picker
                prefix-icon="no_icon"
                v-model="ruleForm.activityStartTime"
                type="datetime"
                placeholder="开始日期"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 185px; font-size: 12px"
                class="time1"
                @change="activityTimeChange"
                :picker-options="pickerOptionsValue"
                :default-time="
                  this.$getDate(30)[0].substring(
                    11,
                    this.$getDate(30)[0].length
                  )
                "
                :clearable="false"
                :disabled="isStart"
              >
              </el-date-picker>
              <div class="time_to_text">至</div>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="ruleForm.activityEndTime"
                type="datetime"
                placeholder="结束日期"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 200px; font-size: 12px"
                class="time2"
                @change="activityTimeChange"
                @focus="orderFocus"
                :picker-options="pickerOptionsValueEnd"
                :default-time="
                  this.$getDate(30)[0].substring(
                    11,
                    this.$getDate(30)[0].length
                  )
                "
                :clearable="false"
              >
              </el-date-picker>
              <i
                class="el-icon-circle-close date_icon1"
                v-if="!isStart"
                @click="clearTime(2)"
              ></i>
              <img
                src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                alt=""
                class="date_icon2"
              />
            </div>
            <span class="lastTime" style="color: #666">
              活动持续 <span style="color: #fe4d45">{{ timeDay }}</span> 天
              <span style="color: #fe4d45">{{ timeOut }}</span> 小时
              <el-tooltip
                class="item"
                effect="light"
                content="活动时间不可超过互动数据授权有效期及店铺接入有效期"
                placement="bottom"
              >
                <el-button type="text" style="width: 35px">
                  <i class="el-icon-question"></i>
                </el-button>
              </el-tooltip>
            </span>
            <div class="act-tip" v-if="isShowTip">
              *提示：修改活动结束时间后，新增的活动时间范围的活动数据无法获取
            </div>
          </el-form-item>
          <el-form-item label="活动对象:" prop="partner">
            <el-radio v-model="actMember" label="1" :disabled="isStart"
              >不限</el-radio
            >
            <el-radio v-model="actMember" label="2" :disabled="isStart"
              >会员身份</el-radio
            >
            <el-radio v-model="actMember" label="3" :disabled="isStart || softType==1"
              >指定人群
              <jd-button
                style="margin-left: 10px"
                v-if="actMember == '3'"
                :disabled="isStart"
                @click="openCrowd"
                >已选人群({{ peopleSelected.length }})</jd-button
              >
            </el-radio>

            <div v-if="actMember == '2'" style="display: flex">
              <span>会员等级：</span>
              <el-checkbox-group
                v-model="ruleForm.partner"
                @change="checkListchange"
                v-if="actMember == '2'"
              >
                <el-checkbox label="-1" name="partner" :disabled="isStart"
                  >全部</el-checkbox
                >
                <el-checkbox
                  label="0"
                  name="partner"
                  :disabled="ruleForm.partner == -1 || isStart"
                  >非会员</el-checkbox
                >

                <el-checkbox
                  v-for="(item, index) in levelList"
                  :key="index"
                  :label="index + 1 + ''"
                  name="partner"
                  :disabled="ruleForm.partner == -1 || isStart"
                  >{{ item }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
            <div v-if="actMember == '2'" style="display: flex">
              <span>入会时间：</span>
              <el-checkbox
                v-model="ruleDto.isCheckOpenCardTime"
                :disabled="isStart"
                >指定时间段</el-checkbox
              >
              <div class="my_select_time" style="margin-left: 8px">
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="ruleDto.openCardStartTime"
                  type="datetime"
                  placeholder="开始日期"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 185px; font-size: 12px"
                  class="time1"
                  :clearable="false"
                  :disabled="!ruleDto.isCheckOpenCardTime || isStart"
                >
                </el-date-picker>
                <div class="time_to_text">至</div>
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="ruleDto.openCardEndTime"
                  type="datetime"
                  placeholder="结束日期"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 200px; font-size: 12px"
                  class="time2"
                  :picker-options="openCardEndTimeOptionsValue"
                  :clearable="false"
                  :disabled="!ruleDto.isCheckOpenCardTime || isStart"
                >
                </el-date-picker>
                <i
                  class="el-icon-circle-close date_icon1"
                  @click="clearNewTime"
                ></i>
                <img
                  src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                  alt=""
                  class="date_icon2"
                />
              </div>
            </div>
            <span v-if="actMember == '2'" style="color: #f56c6c"
              >注意：该条件对【非会员】身份不生效</span
            >

            <span v-if="localStepNum == 3"
              >注：之前关注过店铺和未关注店铺的新粉丝可以参加活动，同一个活动只能参与一次</span
            >
          </el-form-item>
          <el-form-item label="Plus会员身份:" required>
            <el-radio
              v-model="ruleDto.plusObject"
              :label="0"
              :disabled="isStart"
              >不限</el-radio
            >
            <el-radio
              v-model="ruleDto.plusObject"
              :label="1"
              :disabled="isStart"
              >Plus会员</el-radio
            >
            <el-radio
              v-model="ruleDto.plusObject"
              :label="2"
              :disabled="isStart"
              >非plus会员</el-radio
            >
            <div style="color: #f56c6c">
              注意：使用该判断需满足“与京东PLUS团队有合作关系的商家”及“京东PLUS团队准许调用本接口的商家”，否则该条件不生效，保存活动后建议先自行测试无误后再投放。
            </div>
          </el-form-item> -->

          <jd-title label="奖品设置" type="bold"></jd-title>
          <el-form-item label="奖品设置:" prop="setPrize">
            <el-radio
              v-model="ruleForm.isCumulativePrize"
              :label="0"
              :disabled="isStart"
              >统一奖品</el-radio
            >
            <el-radio
              v-model="ruleForm.isCumulativePrize"
              :label="1"
              :disabled="isStart"
              >梯度奖品</el-radio
            >
            <el-radio
              v-model="ruleForm.isCumulativePrize"
              :label="2"
              :disabled="isStart"
              >任务奖品</el-radio
            >
            <el-form-item 
              v-if="ruleForm.isCumulativePrize == 1" 
              class="mt16" 
              label="领奖限制：" 
              label-width="90px"
            >
              <el-radio-group v-model="ruleDto.receiveType" :disabled="isStart">
                <el-radio :label="1">满足所有阶梯均可领奖</el-radio>
                <el-radio :label="0">用户仅可领取其中一个奖品</el-radio>
              </el-radio-group>
            </el-form-item>
            <div
              class="prize_box"
              style="min-width: 970px"
              v-show="ruleForm.isCumulativePrize == 0"
            >
              <!-- Note--添加文案 -->
              <div style="color: red">
                注意：因接口限制，系统只能识别首次邀请入会的用户，因此被邀请者为首次开卡入会的用户才会计为邀请成功
              </div>
              每邀请<el-input
                v-model="ruleForm.inviteNum"
                style="width: 70px; margin: 0 10px"
                @input="ruleForm.inviteNum = getNumberData(1, $event, 0, 1)"
                @blur="inviteNumBlur"
                :disabled="isStart"
              >
              </el-input
              >人可得<span style="color: #fe4d45">{{
                awardSettingsLsit[0].title || ""
              }}</span
              >，活动期间最多邀请<el-input
                v-model="ruleForm.peopleCount"
                style="width: 70px; margin: 0 10px"
                @input="ruleForm.peopleCount = getNumberData(1, $event, 0, 1)"
                @blur="peopleCountBlur"
                :disabled="isStart"
              >
              </el-input
              >人，超出人数不再获得奖励<el-tooltip
                class="item"
                effect="light"
                content="以成功邀请开卡的人数为准"
                placement="bottom"
              >
                <el-button type="text" style="width: 40px">
                  <i style="color: #ccc" class="el-icon-question"></i>
                </el-button>
              </el-tooltip>
              <jd-table
                :tableData="awardSettingsLsit"
                style="
                  width: 1000px;
                  margin-top: 15px;
                "
              >
                <el-table-column label="选择奖品">
                  <template slot-scope="scope">
                    <jd-button
                      type="blueText"
                      @click="selectPacket(scope.$index, scope.row)"
                      >选奖品</jd-button
                    >
                  </template>
                </el-table-column>

                <el-table-column label="奖品类型">
                  <template slot-scope="scope">
                    <span>{{ scope.row.prizeType | prizeType(venderType) }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="值"
                  width="80"
                  prop="price"
                ></el-table-column>
                <el-table-column label="奖品名称（12字内）" width="299">
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.title"
                      maxlength="12"
                      show-word-limit
                      style="width: 240px"
                      placeholder="请输入"
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="奖品数量" width="200">
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.totalAmount"
                      @input.native="
                        (e) =>
                          (scope.row.totalAmount = handleCheckputn(
                            e,
                            scope.row,
                            'jindou'
                          ))
                      "
                      @input="
                        (scope.row.totalAmount = getNumberData(
                          1,
                          $event,
                          0,
                          1
                        )),
                          prizeNum(scope.row)
                      "
                      maxlength="10"
                      class="inputcount"
                      show-word-limit
                      style="width: 150px"
                      placeholder="请输入"
                      @blur="beAdd(scope.row)"
                      :disabled="
                        (activityData.isStart && !scope.row.minNum) ||
                        activityData.isStart
                      "
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="每日发放限额" width="120">
                  <template slot-scope="scope">
                    <dailyLimitConfig
                      :row="scope.row"
                      :backgroundOpacity="backgroundOpacity"
                      :limitBtnDisabled="backgroundOpacity"
                    ></dailyLimitConfig>
                  </template>
                </el-table-column>
                <el-table-column label="操作" v-if="activityData.isStart">
                  <template slot-scope="scope">
                    <jd-button
                      type="blueText"
                      v-if="scope.row.title"
                      @click="itemAddNum('awardSettingsLsit', scope.$index)"
                      >增加奖品数量</jd-button
                    >
                  </template>
                </el-table-column>
              </jd-table>
              <div style="color: red;" v-if="activityData.isStart">提示：修改奖品名称后，已领取的奖品记录依旧不变更名称</div>
            </div>
            <div
              class="prize_box"
              style="min-width: 970px"
              v-show="ruleForm.isCumulativePrize == 1"
            >
              <div>
                <jd-tip color="yello">
                  规则：达到邀请人数的最大人数并领取奖品后，可继续邀请开卡但是不能获得奖品
                </jd-tip>
              </div>

              <jd-table
                :tableData="tableData"
                style="
                  width: 1000px;
                  margin-top: 15px;
                "
              >
                <el-table-column prop="date" label="邀请人数" width="110">
                  <template slot-scope="scope">
                    <el-input
                      @input="
                        scope.row.peopleCount = getNumberData(1, $event, 0, 1)
                      "
                      v-model="scope.row.peopleCount"
                      :disabled="isStart"
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="选择奖品">
                  <template slot-scope="scope">
                    <jd-button @click="centerVis(scope)" type="blueText"
                      >选择奖品</jd-button
                    >
                  </template>
                </el-table-column>

                <el-table-column label="奖品类型">
                  <template slot-scope="scope">
                    <span>{{ scope.row.prizeType | prizeType(venderType) }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="值" width="80" prop="price">
                  <template slot-scope="scope">
                    <span>{{ scope.row.price }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="奖品名称（12字内）" width="299">
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.title"
                      maxlength="12"
                      show-word-limit
                      style="width: 240px"
                      placeholder="请输入"
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="奖品数量" width="200">
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.prizeCount"
                      @input.native="
                        (e) =>
                          (scope.row.prizeCount = checkputnCount(
                            e,
                            scope.row,
                            'jindou'
                          ))
                      "
                      @input="
                        (scope.row.prizeCount = getNumberData(1, $event, 0, 1)),
                          prizeNum(scope.row, 2)
                      "
                      @blur="beAdd(scope.row, 2)"
                      :disabled="
                        (activityData.isStart && !scope.row.minNum) ||
                        activityData.isStart
                      "
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="每日发放限额" width="120">
                  <template slot-scope="scope">
                    <dailyLimitConfig
                      :row="scope.row"
                      :backgroundOpacity="backgroundOpacity"
                      :limitBtnDisabled="backgroundOpacity"
                      totalAmountKey="prizeCount"
                    ></dailyLimitConfig>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="120">
                  <template slot-scope="scope">
                    <jd-button
                      v-if="!isStart"
                      type="blueText"
                      @click="itemDel(scope.$index)"
                      >删除</jd-button
                    >
                    <jd-button
                      type="blueText"
                      v-if="isStart && scope.row.title"
                      @click="itemAddNum('tableData', scope.$index)"
                      >增加奖品数量</jd-button
                    >
                  </template>
                </el-table-column>
              </jd-table>
              <div style="color: red;" v-if="activityData.isStart">提示：修改奖品名称后，已领取的奖品记录依旧不变更名称</div>
              <jd-button
                @click="addPrizeRule"
                type="break"
                style="margin-top: 8px"
                v-if="!isStart"
              >
                增加奖项
              </jd-button>
            </div>
            <div
              class="prize_box"
              style="min-width: 970px"
              v-show="ruleForm.isCumulativePrize == 2"
            >
              <div>
                <jd-tip color="yello">
                  <div>
                    温馨提示规则：<br />
                    <p>
                      设置活动的各个奖项，请尽量确保一个活动中的各个奖项的份数一致，避免某个奖项提前领取完，导致用户看到奖项但无法领取而客诉
                    </p>
                  </div>
                </jd-tip>
              </div>

              <jd-table
                :tableData="taskTableData"
                style="
                  width: 1000px;
                  margin-top: 15px;
                "
              >
                <el-table-column
                  label="任务"
                  width="80"
                  type="index"
                  :index="indexMethod"
                >
                </el-table-column>
                <el-table-column prop="date" label="邀请人数" width="110">
                  <template slot-scope="scope">
                    <el-input
                      @input="
                        scope.row.peopleCount = getNumberData(1, $event, 0, 1)
                      "
                      v-model="scope.row.peopleCount"
                      :disabled="isStart"
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="选择奖品">
                  <template slot-scope="scope">
                    <span
                      @click="centerVis(scope)"
                      style="color: #2768ff; cursor: pointer"
                      >选择奖品</span
                    >
                  </template>
                </el-table-column>

                <el-table-column label="奖品类型">
                  <template slot-scope="scope">
                    <span>{{ scope.row.prizeType | prizeType(venderType) }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="值" width="80" prop="price">
                  <template slot-scope="scope">
                    <span>{{ scope.row.price }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="奖品名称（12字内）" width="299">
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.title"
                      maxlength="12"
                      show-word-limit
                      style="width: 240px"
                      placeholder="请输入"
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="奖品数量" width="130">
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.prizeCount"
                      @input.native="
                        (e) =>
                          (scope.row.prizeCount = checkputnCount(
                            e,
                            scope.row,
                            'jindou'
                          ))
                      "
                      @input="
                        (scope.row.prizeCount = getNumberData(1, $event, 0, 1)),
                          prizeNum(scope.row, 2)
                      "
                      @blur="beAdd(scope.row, 2)"
                      :disabled="
                        (activityData.isStart && !scope.row.minNum) ||
                        activityData.isStart
                      "
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="每日发放限额" width="120">
                  <template slot-scope="scope">
                    <dailyLimitConfig
                      :row="scope.row"
                      :backgroundOpacity="backgroundOpacity"
                      :limitBtnDisabled="backgroundOpacity"
                      totalAmountKey="prizeCount"
                    ></dailyLimitConfig>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="120">
                  <template slot-scope="scope">
                    <jd-button
                      v-if="!isStart"
                      type="blueText"
                      @click="itemDel(scope.$index)"
                      >删除</jd-button
                    >
                    <jd-button
                      type="blueText"
                      v-if="isStart && scope.row.title"
                      @click="itemAddNum('taskTableData', scope.$index)"
                      >增加奖品数量</jd-button
                    >
                  </template>
                </el-table-column>
              </jd-table>
              <div style="color: red;" v-if="activityData.isStart">提示：修改奖品名称后，已领取的奖品记录依旧不变更名称</div>
              <jd-button
                @click="addPrizeRule"
                type="break"
                v-if="!isStart"
                style="margin-top: 8px"
              >
                增加任务
              </jd-button>
            </div>
          </el-form-item>
          <el-form-item label="被邀请有效规则:">
            <div class="radio-width-100">
              <el-radio-group
                v-model="ruleForm.inviteRule"
                :disabled="isStart"
                @change="handleInvite"
              >
                <el-radio :label="0">成功入会</el-radio>
                <el-radio :label="1">成功入会且有下单</el-radio>
                <el-radio :label="2">成功入会且有付款</el-radio>
                <el-popover placement="top-start" trigger="hover">
                  <div>被邀请人有效规则：</div>
                  <div>①成功入会：表示只要邀请入会成功即计入有效邀请人数；</div>
                  <div>
                    ②成功入会且有下单：表示被邀请人既要入会成功，还要有下单行为才计入有效邀请人数（含未付款）；
                  </div>
                  <div>
                    ③成功入会且有付款：表示被邀请人既要入会成功，还要有付款行为才计入有效邀请人数（含退款）；
                  </div>
                  <span
                    slot="reference"
                    style="cursor: pointer; color: #999999; margin-left: -20px"
                    ><i class="new-icon-box" style="margin: -2px 0"></i>
                  </span>
                </el-popover>
              </el-radio-group>
            </div>

            <div
              class="rule_box"
              v-if="ruleForm.inviteRule == 1 || ruleForm.inviteRule == 2"
            >
              <el-form-item label="下单时间:" required>
                <el-select
                  :disabled="isStart"
                  style="margin-right: 10px; width: 110px"
                  v-model="ruleForm.orderTimeType"
                >
                  <el-option label="相对时间" :value="1"></el-option>
                  <el-option label="绝对时间" :value="2"></el-option>
                </el-select>
                <el-input
                  style="width: 160px"
                  :disabled="isStart"
                  v-model="ruleForm.dayNum"
                  @input.native="limitInput($event)"
                  v-if="ruleForm.orderTimeType == 1"
                  placeholder="邀请后X天"
                />
                <div class="my_select_time" v-else>
                  <el-date-picker
                    prefix-icon="no_icon"
                    v-model="ruleForm.orderStartTime"
                    :disabled="isStart"
                    type="datetime"
                    :placeholder="'开始时间'"
                    size="small"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    style="width: 145px; font-size: 12px"
                    class="time1"
                    :clearable="false"
                    :picker-options="startTimeOption"
                  ></el-date-picker>
                  <div class="time_to_text" style="margin-top: 1px !important">
                    至
                  </div>
                  <el-date-picker
                    prefix-icon="no_icon"
                    v-model="ruleForm.orderEndTime"
                    type="datetime"
                    :placeholder="'结束时间'"
                    size="small"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    style="width: 155px; font-size: 12px"
                    class="time2"
                    :disabled="isStart"
                    :clearable="false"
                    :picker-options="endTimeOption"
                    default-time="23:59:59"
                  ></el-date-picker>
                  <i
                    class="el-icon-circle-close date_icon1"
                    @click="clearEffectTime()"
                  ></i>
                  <img
                    src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                    alt
                    class="date_icon2"
                  />
                </div>
              </el-form-item>
              <template v-if="ruleForm.inviteRule == 2">
                <el-form-item label="金额统计类型:" required>
                  <el-radio
                    v-model="ruleForm.popOrderStartPaymentType"
                    :disabled="isStart || venderType"
                    :label="0"
                  >
                    实付金额
                  </el-radio>
                  <el-radio
                    class="oneOrder"
                    v-model="ruleForm.popOrderStartPaymentType"
                    :disabled="isStart"
                    :label="1"
                  >
                    订单金额
                  </el-radio>
                  <div class="memberTips" style="margin-right: 30px">
                    <div>1.注意：由于接口原因，自营仅支持统计订单金额，pop可按需选择统计实付金额或订单金额。</div>
                    <div>2.订单金额是指京东后台价，不等于商城前台页面展示的价格，前台页面无法查看该后台价格；如需查询后台价格，请联系采销核实。</div>
                  </div>
                </el-form-item>
                <el-form-item label="订单金额：">
                  大于等于<el-input
                    style="width: 120px; margin: 0 8px"
                    v-model="ruleForm.orderStartPayment"
                    :disabled="isStart"
                    @input="validateInput"
                  />元
                </el-form-item>
                <el-form-item label="商品件数：">
                  大于等于<el-input
                    style="width: 120px; margin: 0 8px"
                    v-model="ruleForm.itemStartCount"
                    @input="validateInputNew"
                    :disabled="isStart"
                  />件
                </el-form-item>
                <el-form-item label="指定购买商品:" required>
                  <el-radio
                    v-model="ruleForm.skuType"
                    @change="filterTypeChange"
                    :label="0"
                    :disabled="isStart"
                  >
                    全部商品
                  </el-radio>
                  <el-radio
                    v-model="ruleForm.skuType"
                    @change="filterTypeChange"
                    :label="1"
                    :disabled="isStart"
                    >指定商品</el-radio
                  >
                  <el-radio
                    v-model="ruleForm.skuType"
                    @change="filterTypeChange"
                    :label="2"
                    :disabled="isStart"
                    >排除商品</el-radio
                  >
                  <jd-button
                    :class="[{ 'global-view-btn': backgroundOpacity }]"
                    :disabled="
                      backgroundOpacity || ruleForm.skuType == 0 || isStart
                    "
                    @click="showGoods"
                  >
                    {{
                      selectGoodsSkuList &&
                      !!selectGoodsSkuList.length &&
                      selectGoodsSkuList.length != ""
                        ? "已选择" + "(" + selectGoodsSkuList.length + "个)"
                        : "+添加"
                    }}
                  </jd-button>
                </el-form-item>
              </template>
            </div>
          </el-form-item>
          <el-form-item label="过滤规则:">
            <div class="radio-width-100">
              <el-radio-group v-model="ruleForm.filterRule" :disabled="isStart">
                <el-radio :label="0">过滤同一活动中被邀请过的人</el-radio>
                <el-radio :label="1">过滤所有活动中被邀请过的人</el-radio>
                <el-popover placement="top-start" trigger="hover">
                  <div>被邀请人过滤规则:</div>
                  <div>
                    ①过滤同一活动中被邀请过的人:即表示同一个人在同一个活
                    动中仅能被有效邀请1次；
                  </div>
                  <div>
                    ②过滤所有活动中被邀请过的人:即表示同一个人在所有活动
                    中仅能被有效邀请1次;
                  </div>
                  <span
                    slot="reference"
                    style="cursor: pointer; color: #999999; margin-left: -20px"
                    ><i class="new-icon-box" style="margin: -2px 0"></i>
                  </span>
                </el-popover>
              </el-radio-group>
            </div>
          </el-form-item>
          <activityPageSettings 
            isShowShopName
            isShowMoreSet
            v-model="ruleForm"
            :giftList="tempSwitchList"
            :templateId="1"
            :cusTemplateJSON.sync="ruleDto.cusTemplateJSON"
            :isNeedCustomerPaperworkData="false"
            :widthNumber="750"
            :heightNumber="3110"
            :designSpecificationsUrl="designSpecificationsList[activityData.id]"
          />
          <exposureList 
            v-model="itemListFor"
            :defaultExposureSwitch.sync="ruleForm.exposureSwitch"
          />
          <!-- <jd-title label="曝光商品" type="bold"></jd-title>
          <el-form-item label="曝光商品:" class="zindexBox" prop="exposure">
            <el-checkbox v-model="ruleForm.exposureSwitch">
              是否添加曝光商品
            </el-checkbox>
            <jd-button
              :class="[{ 'global-view-btn': backgroundOpacity }]"
              style="margin: 0 15px"
              @click="exposureProducts"
              :disabled="ruleForm.exposureSwitch == false"
            >
              {{
                itemListFor.length != ""
                  ? "添加曝光商品" + "(" + itemListFor.length + "/20" + ")"
                  : "添加曝光商品"
              }}
            </jd-button>
            <el-radio-group
              v-model="ruleForm.radio"
              :disabled="ruleForm.exposureSwitch == false"
            >
              <el-radio :label="0">显示京东价</el-radio>
            </el-radio-group>
            <draggable
              v-if="itemListFor.length > 0"
              v-model="mainImagelist"
              chosen-class="chosen"
              :scroll="true"
              animation="150"
              force-fallback="true"
              @start="isDragging = true"
              @end="onEnd"
              style="
                margin-top: 10px;
                background: rgba(38, 112, 251, 0.06);
                padding: 10px;
              "
              filter=".unmover"
            >
              <transition-group type="transition">
                <div
                  v-for="(item, index) in mainImagelist"
                  :key="item.skuId"
                  style="display: inline-block; position: relative"
                  class="show_upImg2"
                >
                  <img
                    :src="item.logo"
                    width="120px"
                    height="120px"
                    style="display: inline-block"
                  />&nbsp;
                  <div class="delectPosible">
                    <span class="delectSort">拖动排序</span>
                    <img
                      src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/pages/delet.svg"
                      @click.stop="delec(index)"
                      class="delectIcom"
                    />
                  </div>
                </div>
              </transition-group>
            </draggable>
          </el-form-item> -->
          <!-- <template> -->
          <sharFrom 
            v-model="ruleForm"
            :sharePic="sharePic"
          />
          <!-- <jd-title label="分享设置" type="bold"></jd-title>
          <el-form-item label="小程序分享标题:" required>
            <el-input
              type="text"
              style="width: 425px; margin-left: 8px"
              show-word-limit
              v-model="ruleForm.shareTitle"
              :maxlength="28"
              :disabled="isStart"
            ></el-input>
          </el-form-item>
          <el-form-item label="小程序分享简介:" required>
            <el-input
              type="text"
              style="width: 425px; margin-left: 8px"
              show-word-limit
              v-model="ruleForm.shareIntroduce"
              :maxlength="28"
              :disabled="isStart"
            ></el-input>
          </el-form-item>
          <el-form-item label="小程序分享图片:" required>
            <div class="miniAppPic" style="margin-left: 4px">
              <div class="top">
                <el-upload
                  class="upload"
                  action="/jd-hd-web/image/upload"
                  :show-file-list="false"
                  :before-upload="beforeUpload1"
                  :on-success="handleUpload1"
                  :disabled="isStart"
                >
                  <jd-button type="blueText">自定义上传</jd-button>
                </el-upload>
                <jd-button
                  type="blueText"
                  style="margin-left: 20px"
                  @click="picUrlReset1"
                  >重置</jd-button
                >
              </div>
              <div class="bottoms">
                <el-image class="elImg" :src="ruleForm.sharePic" fit="contain">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-plus"></i>
                  </div>
                </el-image>
                <div class="tips1">
                  <p>建议上传尺寸：200px * 200px</p>
                  <p>图片大小：1MB以内</p>
                  <p>格式：jpg、png</p>
                </div>
              </div>
            </div>
          </el-form-item> -->
          <!-- </template> -->
          <activityRules
            v-model="ruleForm.activityRulesText"
            :isForceRemind.sync="ruleDto.isForceRemind"
            :isKeyActivity.sync="isKeyActivity"
            :placementPosition.sync="placementPosition"
            :activityData="activityData"
            :valueRow="valueRow"
            @generateRule="generateRule"
          />
          <!-- <jd-title label="活动规则" type="bold"></jd-title>
          <el-form-item label="规则内容:" required>
            <div
              style="
                width: 570px;
                backgroundcolor: rgba(250, 250, 250, 1);
                padding: 8px;
                position: relative;
              "
            >
              <el-input
                type="textarea"
                class="textarea"
                style="width: 543px"
                resize="none"
                v-model="ruleForm.activityRulesText"
                :maxlength="2000"
              ></el-input>
              <div class="prosi" style="color: #909399">
                （{{
                  ruleForm.activityRulesText.length
                    ? ruleForm.activityRulesText.length
                    : 0
                }}/2000）
              </div>
            </div>
            <div style="margin-top: 16px; margin-left: 7px">
              <jd-button type="blue" plain @click="generateRule">
                生成规则
              </jd-button>
            </div>
            <div class="rule-tip">
              <jd-tip color="gley">
                提示：点击按钮自动生成规则，也可以自己编辑信息，手机端规则处显示
              </jd-tip>
            </div>
          </el-form-item> -->

          <!-- <div v-if="backgroundOpacity" class="backgroundOpacity"></div> -->
        </el-form>
      </div>
    </div>
    <div class="create_bottom" v-if="localStep != 99">
      <jd-button
        v-show="!itemId && backgroundOpacity"
        style="margin-right: 8px"
        @click="clickLocalStep()"
        >{{ backgroundOpacity ? "返回列表" : "返回上一步" }}</jd-button
      >
      <jd-button @click="saveDraft" style="margin-right: 8px" v-if="hasDraftBtn"
        >保存至草稿箱</jd-button
      >
      <template v-if="!backgroundOpacity">
        <jd-button
          v-show="!itemId"
          v-if="isSave"
          type="blue"
          @click="saveEdit"
          v-preventReClick
          >保存设置</jd-button
        >
      </template>
      <jd-button v-show="itemId" style="margin-right: 8px" @click="cancelEdit"
        >取消</jd-button
      >
      <el-button v-show="itemId" type="blue">保存设置</el-button>
    </div>
    <!-- 添加曝光商品 -->
    <selectGoodsMonitor
      v-if="selectGoodsState"
      ref="selectGo"
      :isShow="selectGoodsState"
      @close="selectGoodsClose"
      :selectGoods="selectGoodsArr"
      :moduleType="true"
      :skuSearch="true"
      :xianz="true"
      :disabled="backgroundOpacity"
    ></selectGoodsMonitor>
    <!-- :skuSearch="true" -->
    <!-- 保存并完成设置弹框 -->
    <el-dialog
      title="重要提示"
      :visible.sync="joinBlackList"
      width="800"
      @close="checked = false"
    >
      <div style="line-height: 25px; margin-bottom: 30px">
        <p>
          1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
        </p>
        <p>
          2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
        </p>
      </div>

      <el-checkbox v-model="checked" label="地址" name="partner"
        >我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox
      >
      <div slot="footer" class="dialog-footer">
        <jd-button @click="joinBlackList = false" style="margin-right: 8px"
          >取消</jd-button
        >
        <jd-button @click="handleDialogCloseAnoth()" type="blue"
          >确 定</jd-button
        >
      </div>
    </el-dialog>
    <!-- 红包雨 选择奖品弹窗 -->
    <selectProduct
      ref="selectProductAward"
      v-if="showSelectProductAward"
      :echoDate="echoDate"
      :actId="valueRow"
      :isShowFirst="activityData.name == '邀请开卡有礼' ? false : true"
      :num="1"
      :JingdouCount="JingdouCount"
      :actType="activityData.id"
      :actEndTime="ruleForm.endTime"
      @choose-shop="getTheDataAward"
    >
    </selectProduct>
    <!-- 选择奖品弹窗 -->
    <selectProduct
      :putPrize="putPrize"
      :echoDate="echoDate"
      :actId="valueRow"
      @close="colseDialog"
      :isShowFirst="activityData.name == '邀请开卡有礼' ? false : true"
      v-if="showDialog"
      ref="selectProduct"
      :actType="activityData.id"
      :actEndTime="ruleForm.endTime"
      @choose-shop="getTheData"
    >
    </selectProduct>
    <!-- 选择人群 -->
    <selectPeople
      v-if="selectPeopleShow"
      :dialogVisible="selectPeopleShow"
      :peopleList="peopleList"
      @confim="selectPeopleSure"
      @close="selectPeopleShow = false"
    ></selectPeople>
    <!-- 增加奖品弹窗 -->
    <addPrizeNum
      :isShowAddNum="isShowAddNum"
      :prizeData="toAddItem"
      @confirm="confirmAdd"
      @close="isShowAddNum = false"
    />
    <!-- 选择商品弹窗 -->
    <selectGoodsMonitor
      v-if="goodsState"
      ref="selectSkuGoods"
      :isShow="goodsState"
      @close="skuSelectGoodsChange"
      :selectGoods="selectGoodsSkuList"
      :moduleType="true"
      :skuSearch="true"
      :xianz="false"
      :disabled="backgroundOpacity"
    ></selectGoodsMonitor>
  </div>
</template>

<script>
import activityPageSettings from "./components/activityPageSettings.vue"
import informationForm from "./components/informationForm.vue"
import exposureList from "./components/exposureList.vue"
import sharFrom from "./components/sharFrom.vue"
import activityRules from "./components/activityRules.vue"
import selectPeople from "@/components/select-people-yunqi.vue";
import {
  invite,
  editInvite,
  searchInvite,
  updateCommon,
} from "@/api/jhk/integralCenter/integralTask";
import { jingdouList } from "@/api/jhk/integralCenter/prizeCenter.js";
import { querymemberLevel } from "@/api/jhk/integralCenter/memberLevel";
import selectProduct from "./select_product_componentization.vue";
import QRCode from "qrcodejs2";
import selectGoodsMonitor from "@/components/selectGoodsMonitor2.vue";
import draggable from "vuedraggable";
import addPrizeNum from "./components/add-prize-num.vue";
import SelectGoods from "@/components/selectGoodsMonitor";
import { getTaobaoItemListSku } from "@/api/jhk/analysis/ware-controller";
import dailyLimitConfig from "@/views/interactiveMarketing/activity/components/dailyLimitConfig.vue";
import { useValidateMoreActSet } from "@/views/interactiveMarketing/activity/components/commDataHook/useBasicInformation.js";

export default {
  components: {
    selectProduct,
    SelectGoods,
    selectGoodsMonitor,
    draggable,
    selectPeople,
    addPrizeNum,
    activityPageSettings,
    informationForm,
    exposureList,
    sharFrom,
    activityRules,
    dailyLimitConfig,
  },
  props: {
    itemId: "",
    stepNum: {
      type: Number,
      default: 0,
    },
    activeValue: {
      type: Number,
    },
    valueRow: null,
    activityData: {
      type: Object,
    },
    isSave: {
      type: Boolean,
      default: true,
    },
    backgroundOpacity: {
      type: Boolean,
      default: false,
    },
    isDraftEdit: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.isStart = this.activityData.isStart;
    console.log("当前玩法id", this.activityData.id);
    this.sharePic = this.getDefaultSharePic(this.activityData.id);
    this.ruleForm.sharePic = this.sharePic;
    this.ruleForm.shareTitle = `我分享了一个${this.activityData.name}活动给你，快来看看吧！`;
    this.ruleForm.shareIntroduce = `我在京东有新发现，绝对适合你，速来围观～`;
    if (this.venderType) {
      this.ruleForm.popOrderStartPaymentType = 1;
    }
    if (this.activeValue == 5) {
      //邀请开卡
      searchInvite({ id: this.valueRow.id }).then((res) => {
        this.ruleForm.isCumulativePrize = res.data.ruleDto.isCumulativePrize
          ? 1
          : 0;
        this.ruleForm.shareTitle = res.data.ruleDto.shareTitle;
        this.ruleForm.shareIntroduce = res.data.ruleDto.shareIntroduce;
        this.ruleForm.sharePic = res.data.ruleDto.sharePic;

        if (res.data.ruleDto.isTaskPrize) {
          this.ruleForm.isCumulativePrize = 2;
        }
        if (this.ruleForm.isCumulativePrize) {
          if (this.ruleForm.isCumulativePrize == 1) {
            this.tableData = res.data.ruleDto.cumulativePrizes.map(
              (item, index) => {
                let obj = {
                  peopleCount: item.cumulativeNum,
                  title: item.cumulativePrizeDTO.title,
                  assetsId: item.cumulativePrizeDTO.assetsId,
                  prizeType: item.cumulativePrizeDTO.prizeType,
                  logo: item.cumulativePrizeDTO.logo,
                  price:
                    item.cumulativePrizeDTO.price ||
                    item.cumulativePrizeDTO.singleAmount,
                  singleAmount: item.cumulativePrizeDTO.singleAmount,
                  prizeCount: item.cumulativePrizeDTO.totalAmount,
                  minNum: item.cumulativePrizeDTO.totalAmount,
                  id: item.cumulativePrizeDTO.pointActivityPrizeId,
                  pointActivityPrizeId: item.cumulativePrizeDTO.pointActivityPrizeId,
                  isFollowActivityEndTime: item.cumulativePrizeDTO.isFollowActivityEndTime,
                  addressFillEndTime: item.cumulativePrizeDTO.addressFillEndTime,
                  predictSendTime: item.cumulativePrizeDTO.predictSendTime,
                  shouldCollectExtraData: item.cumulativePrizeDTO.shouldCollectExtraData, //是否需要额外信息
                  extraQuestion: item.cumulativePrizeDTO.extraQuestion, //额外问题
                  addressFillLimit: item.cumulativePrizeDTO.addressFillLimit,
                  dailyLimit: item.cumulativePrizeDTO.dailyLimit,
                  dailyLimitType: item.cumulativePrizeDTO.dailyLimitType,
                  idleLimit: item.cumulativePrizeDTO.idleLimit,
                  busyLimit: item.cumulativePrizeDTO.busyLimit,
                  prizeGoShop: item.cumulativePrizeDTO.prizeGoShop,
                };
                // 提交地址限制回显：逗号分隔字符串转数字数组
                if (obj.prizeType == 3) {
                  if (item.cumulativePrizeDTO.commitAddressLimit) {
                    obj.commitAddressLimit = typeof item.cumulativePrizeDTO.commitAddressLimit === 'string'
                      ? item.cumulativePrizeDTO.commitAddressLimit.split(',').map(Number)
                      : item.cumulativePrizeDTO.commitAddressLimit;
                  } else {
                    obj.commitAddressLimit = [0];
                  }
                }
                if (obj.prizeType == 1) {
                  obj.couponType = item.cumulativePrizeDTO.couponType;
                }
                if (obj.prizeType == 14) {
                  obj.pointActivityPrizeRemark = item.cumulativePrizeDTO.pointActivityPrizeRemark;
                  obj.isGoodManage = item.cumulativePrizeDTO.isGoodManage||0;
                }
                return obj;
              }
            );
            console.log(this.tableData);
          } else {
            this.taskTableData = res.data.ruleDto.cumulativePrizes.map(
              (item, index) => {
                let obj = {
                  peopleCount: item.cumulativeNum,
                  title: item.cumulativePrizeDTO.title,
                  assetsId: item.cumulativePrizeDTO.assetsId,
                  prizeType: item.cumulativePrizeDTO.prizeType,
                  logo: item.cumulativePrizeDTO.logo,
                  price:
                    item.cumulativePrizeDTO.price ||
                    item.cumulativePrizeDTO.singleAmount,
                  singleAmount: item.cumulativePrizeDTO.singleAmount,
                  prizeCount: item.cumulativePrizeDTO.totalAmount,
                  minNum: item.cumulativePrizeDTO.totalAmount,
                  id: item.cumulativePrizeDTO.pointActivityPrizeId,
                  pointActivityPrizeId: item.cumulativePrizeDTO.pointActivityPrizeId,
                  isFollowActivityEndTime: item.cumulativePrizeDTO.isFollowActivityEndTime,
                  addressFillEndTime: item.cumulativePrizeDTO.addressFillEndTime,
                  predictSendTime: item.cumulativePrizeDTO.predictSendTime,
                  shouldCollectExtraData: item.cumulativePrizeDTO.shouldCollectExtraData, //是否需要额外信息
                  extraQuestion: item.cumulativePrizeDTO.extraQuestion, //额外问题
                  addressFillLimit: item.cumulativePrizeDTO.addressFillLimit,
                  dailyLimit: item.cumulativePrizeDTO.dailyLimit,
                  dailyLimitType: item.cumulativePrizeDTO.dailyLimitType,
                  idleLimit: item.cumulativePrizeDTO.idleLimit,
                  busyLimit: item.cumulativePrizeDTO.busyLimit,
                  prizeGoShop: item.cumulativePrizeDTO.prizeGoShop,
                };
                // 提交地址限制回显：逗号分隔字符串转数字数组
                if (obj.prizeType == 3) {
                  if (item.cumulativePrizeDTO.commitAddressLimit) {
                    obj.commitAddressLimit = typeof item.cumulativePrizeDTO.commitAddressLimit === 'string'
                      ? item.cumulativePrizeDTO.commitAddressLimit.split(',').map(Number)
                      : item.cumulativePrizeDTO.commitAddressLimit;
                  } else {
                    obj.commitAddressLimit = [0];
                  }
                }
                if (obj.prizeType == 1) {
                  obj.couponType = item.cumulativePrizeDTO.couponType;
                }
                if (obj.prizeType == 14) {
                  obj.pointActivityPrizeRemark = item.cumulativePrizeDTO.pointActivityPrizeRemark;
                  obj.isGoodManage = item.cumulativePrizeDTO.isGoodManage||0;
                }
                return obj;
              }
            );
          }
        } else {
          let prize = res.data.ruleDto.cumulativePrizes;
          console.log(prize[0]);
          // 兼容草稿箱
          if (prize && prize.length) {
            this.ruleForm.prizeCount = prize[0].totalAmount;
            this.prizeSettingList = {
              ...prize[0].cumulativePrizeDTO,
              singleAmount: prize[0].cumulativePrizeDTO.singleAmount,
              title: prize[0].cumulativePrizeDTO.title,
              assetsId: prize[0].cumulativePrizeDTO.assetsId,
              prizeType: prize[0].cumulativePrizeDTO.prizeType,
              logo: prize[0].cumulativePrizeDTO.logo,
              price: prize[0].cumulativePrizeDTO.price,
              discount: prize[0].cumulativePrizeDTO.singleAmount,
              minNum: prize[0].cumulativePrizeDTO.totalAmount,
              id: prize[0].cumulativePrizeDTO.pointActivityPrizeId,
              pointActivityPrizeId: prize[0].cumulativePrizeDTO.pointActivityPrizeId,
              isFollowActivityEndTime: prize[0].cumulativePrizeDTO.isFollowActivityEndTime,
              addressFillEndTime: prize[0].cumulativePrizeDTO.addressFillEndTime,
              predictSendTime: prize[0].cumulativePrizeDTO.predictSendTime,
              shouldCollectExtraData: prize[0].cumulativePrizeDTO.shouldCollectExtraData, //是否需要额外信息
              extraQuestion: prize[0].cumulativePrizeDTO.extraQuestion, //额外问题
              addressFillLimit: prize[0].cumulativePrizeDTO.addressFillLimit,
              dailyLimit: prize[0].cumulativePrizeDTO.dailyLimit,
              dailyLimitType: prize[0].cumulativePrizeDTO.dailyLimitType,
              idleLimit: prize[0].cumulativePrizeDTO.idleLimit,
              busyLimit: prize[0].cumulativePrizeDTO.busyLimit,
              prizeGoShop: prize[0].cumulativePrizeDTO.prizeGoShop,
            };
            // 提交地址限制回显：逗号分隔字符串转数字数组
            if (this.prizeSettingList.prizeType == 3) {
              if (prize[0].cumulativePrizeDTO.commitAddressLimit) {
                this.prizeSettingList.commitAddressLimit = typeof prize[0].cumulativePrizeDTO.commitAddressLimit === 'string'
                  ? prize[0].cumulativePrizeDTO.commitAddressLimit.split(',').map(Number)
                  : prize[0].cumulativePrizeDTO.commitAddressLimit;
              } else {
                this.prizeSettingList.commitAddressLimit = [0];
              }
            }
            if (this.prizeSettingList.prizeType == 14) {
              this.prizeSettingList.pointActivityPrizeRemark = prize[0].cumulativePrizeDTO.pointActivityPrizeRemark;
              this.prizeSettingList.isGoodManage = prize[0].cumulativePrizeDTO.isGoodManage||0;
            }
            // this.setPrizeTxt(this.prizeSettingList);
            this.awardSettingsLsit = [this.prizeSettingList];
          }
          this.ruleForm.peopleCount = res.data.ruleDto.maxInviteNum || "";
          this.ruleForm.inviteNum = res.data.ruleDto.inviteNum || "";
        }
        this.ruleForm.activityName = res.data.activityName;
        this.ruleForm.activityName =
          res.data.activityName + (this.activityData.isCopy ? "复制" : "");
        this.ruleForm.activityStartTime = res.data.startTime
          ? String(res.data.startTime)
          : null;
        this.ruleForm.activityEndTime = res.data.endTime
          ? String(res.data.endTime)
          : null;
        this.actEndTime = res.data.endTime;
        this.ruleForm.activityRulesText = String(res.data.ruleDescription); //生成规则
        this.ruleForm.partner = res.data.allowLevel.split(",");
        this.ruleForm.isValidBlackList = res.data.isValidBlackList || 0;
        // 学生身份
        this.ruleForm.studentSatus = res.data.studentSatus || "";
        let nowDto = Object.assign({ ...res.data.ruleDto });
        this.ruleForm.shopNameType = nowDto.customerPaperwork ? JSON.parse(nowDto.customerPaperwork).shopNameType : 0;
        this.customerPaperwork = nowDto.customerPaperwork ? JSON.parse(nowDto.customerPaperwork) : {};
        let customerPaperwork = {}
        if(nowDto.customerPaperwork) {
          customerPaperwork = JSON.parse(nowDto.customerPaperwork);
        }
        this.ruleForm.moreActSet = customerPaperwork.moreActSet ? customerPaperwork.moreActSet : {
          isShowFloatWindow: 0,//是否显示活动浮窗：0-不显示，1-显示
          floatWindowImg: "",//活动浮窗图片
          goShopSetting: 0,//活动浮窗跳转设置
          goShopAppId: "",//活动浮窗跳转小程序ID
          goShopUrl: "",//活动浮窗跳转链接
          isShowBanner: 0,//是否显示活动banner：0-不显示，1-显示
          bannerList: [],//banner列表
        },
        console.log("nowDto", nowDto);
        this.ruleForm.inviteRule = (nowDto.hasOwnProperty("inviteRule") && nowDto.inviteRule!=null)
          ? Number(nowDto.inviteRule)
          : 0;
        this.ruleForm.orderTimeType = (nowDto.hasOwnProperty("orderTimeType") && nowDto.orderTimeType!=null)
          ? Number(nowDto.orderTimeType)
          : 1;
        this.ruleForm.dayNum = (nowDto.hasOwnProperty("dayNum") && nowDto.dayNum!=null)
          ? String(nowDto.dayNum)
          : "";
        this.ruleForm.orderStartTime = (nowDto.hasOwnProperty("orderStartTime") && nowDto.orderStartTime!=null)
          ? String(nowDto.orderStartTime)
          : null;
        this.ruleForm.orderEndTime = (nowDto.hasOwnProperty("orderEndTime") && nowDto.orderEndTime!=null)
          ? String(nowDto.orderEndTime)
          : null;
        this.ruleForm.orderStartPayment = (nowDto.hasOwnProperty(
          "orderStartPayment"
        ) && nowDto.orderStartPayment!=null)
          ? String(nowDto.orderStartPayment)
          : "";
        this.ruleForm.itemStartCount = (nowDto.hasOwnProperty("itemStartCount") && nowDto.itemStartCount!=null)
          ? String(nowDto.itemStartCount)
          : "";
        this.ruleForm.skuType = nowDto.skuType;
        if (nowDto.skuIds) {
          this.ruleForm.skuIds = nowDto.skuIds;
          let skuIdsLength = nowDto.skuIds.join(",").length;
          getTaobaoItemListSku({
            current: 1,
            size: skuIdsLength,
            skuIds: nowDto.skuIds,
          }).then((res) => {
            this.selectGoodsSkuList = res.data.records;
            this.ruleForm.selectGoodsSkuList = res.data.records;
          });
        } else {
          this.ruleForm.skuIds = [];
          this.selectGoodsSkuList = [];
          this.ruleForm.selectGoodsSkuList = [];
        }
        if (this.venderType) {
          this.ruleForm.popOrderStartPaymentType = 1;
        } else {
          this.ruleForm.popOrderStartPaymentType = (nowDto.hasOwnProperty(
            "popOrderStartPaymentType"
          ) && nowDto.popOrderStartPaymentType!=null)
            ? Number(nowDto.popOrderStartPaymentType)
            : 0;
        }
        this.ruleForm.filterRule = (nowDto.hasOwnProperty("filterRule") && nowDto.filterRule!=null)
          ? Number(nowDto.filterRule)
          : 0;

        // 1.14迭代 这里回显
        this.ruleDto = {
          isCheckOpenCardTime: res.data.ruleDto.isCheckOpenCardTime,
          openCardStartTime: res.data.ruleDto.openCardStartTime,
          openCardEndTime: res.data.ruleDto.openCardEndTime,
          plusObject: res.data.ruleDto.plusObject, //plus会员
          isForceRemind: res.data.ruleDto.isForceRemind,
          cusTemplateJSON: res.data.ruleDto.cusTemplateJSON,
          receiveType: res.data.ruleDto.receiveType >=0 ? res.data.ruleDto.receiveType : 1,
        };
        this.isKeyActivity = res.data.isKeyActivity||0;
        this.placementPosition = res.data.placementPosition ? res.data.placementPosition.split(",") : ["SHOP"];

        this.ruleForm.firstOpenCardTimeType = res.data.ruleDto.firstOpenCardTimeType;
        this.ruleForm.openCardBeforeDay = res.data.ruleDto.openCardBeforeDay;

        this.ruleForm.exposureSwitch =
          res.data.isExposureItem == 0 ? false : true;
        this.selectGoodsArr = res.data.itemList;
        this.itemListFor = res.data.itemList;
        this.mainImagelist = res.data.itemList;
        this.ruleForm.radio = res.data.priceType;
        this.activityTimeChange();
        if (res.data.allowLevel == "99") {
          this.peopleSelected = res.data.crowdIds.split(",");
          this.actMember = "3";
        } else if (res.data.allowLevel == "-1") {
          this.actMember = "1";
        } else {
          this.actMember = "2";
          if (res.data.allowLevel.indexOf("-1") != -1) {
            this.ruleForm.partner = ["-1"];
          }
        }
        if (this.activityData.isCopy) {
          this.ruleForm.activityRulesText = "";
          this.ruleForm.isCumulativePrize = 0;
          this.ruleForm.inviteNum = "";
          this.ruleForm.peopleCount = "";
          this.awardSettingsLsit = [
            {
              prizeType: null,
              price: null,
              title: "",
              totalAmount: null,
              awardMinScore: null,
              awardMaxScore: null,
              awardLevel: null,
            },
          ];
          // 置空曝光商品
          this.ruleForm.exposureSwitch = false;
          this.selectGoodsArr = [];
          this.itemListFor = [];
          this.mainImagelist = [];
          this.ruleForm.radio = 0;
        }
      });
    }
    // 新增活动默认时间
    if (!this.valueRow) {
      this.ruleForm.activityStartTime = this.$getDate(30)[0];
      this.ruleForm.activityEndTime = this.$getDate(30)[1];
      this.activityTimeChange();
    }
  },
  filters: {
    prizeType(num,type) {
      var result = "";
      if (num == "1") {
        result = "优惠券";
      } else if (num == "2") {
        result = "京豆";
      } else if (num == "3") {
        result = "实物";
      } else if (num == "4") {
        result = "店铺积分";
      } else if (num == "5") {
        result = "京东E卡";
      } else if (num == "6") {
        result = "爱奇艺会员";
      } else if (num == "7") {
        result = "京东PLUS会员";
      } else if (num == "8") {
        result = "现金红包";
      } else if (num == "10") {
        result = "礼品卡";
      } else if (num == "10") {
        result = "礼品卡";
      } else if (num == "13") {
        result = "令牌";
      } else if (num == "12") {
        result = type ? "令牌" : '专享价';
      } else if (num == "14") {
        result = "实物（随单发）";
      } 
      return result;
    },
  },
  computed: {
    // 判断是否有草稿箱按钮
    hasDraftBtn() {
      return this.isDraftEdit || !this.valueRow || this.activityData.isCopy;
    },
    venderType() {
      return this.$store.getters.loginUserInfo.venderType;
    },
    // 1: 京获客旗舰版
    softType() {
      return this.$store.getters.loginUserInfo.yunZhouOtherType || '';
    },
  },
  mounted() {
    this.getLevel();
    this.activityTimeChange();
    this.$nextTick(() => {
      this.$refs.queryId &&
        this.qrcodeAll(this.activityData.telCode, this.$refs.queryId);
    });
    //存储拖拽前的数据
    this.mainImagelist = JSON.parse(sessionStorage.getItem("mainImagelist"));
    console.log(this.activeValue, 99996);
  },
  data() {
    return {
      customerPaperwork: {},
      isKeyActivity: 0,
      placementPosition: [],
      actEndTime: "",
      isShowTip: false,
      showSelectProductAward: false,
      // 1.14迭代
      ruleDto: {
        isCheckOpenCardTime: false,
        openCardStartTime: "",
        openCardEndTime: "",
        plusObject: 0, //plus会员
        isForceRemind: false,
        cusTemplateJSON: "",
        receiveType: 1, //  0 仅可领取一次 1可领取全部 isCumulativePrize=true时使用（默认1）
      },
      openCardStartTimeOptionsValue: {
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 8.64e7 ||
            time.getTime() >
              new Date(this.ruleDto.openCardEndTime).valueOf() -
                24 * 60 * 60 * 1000
          );
        },
      },
      openCardEndTimeOptionsValue: {
        disabledDate: (time) => {
          return (
            time.getTime() < new Date(this.ruleDto.openCardStartTime).valueOf()
          );
        },
      },

      actMember: "1",
      selectPeopleShow: false,
      peopleList: [],
      peopleSelected: [],
      tempSwitchList: [
        {
          isVisible: true,
          title: "全部",
          imageUrl: this.activityData.telImg,
          secondImageUrl: this.activityData.telImg,
          imageName: "邀请开卡有礼",
          id: 1,
        },
      ],
      JingdouCount: {
        prizeCount: 0,
      },
      echoDate: {},
      awardIndex: 0,
      awardSettingsLsit: [
        {
          prizeType: null,
          price: null,
          title: "",
          totalAmount: null,
          awardMinScore: null,
          awardMaxScore: null,
          awardLevel: null,
        },
      ],
      defaultTime: [
        this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length),
        this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length),
      ],
      activityTimeValue: this.$getDate(30),
      pickerOptionsValue: {
        disabledDate: (time) => {
          if (this.ruleForm.activityEndTime) {
            return (
              time.getTime() < Date.now() - 8.64e7 ||
              time.getTime() > new Date(this.ruleForm.activityEndTime).valueOf()
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      pickerOptionsValueEnd: {
        disabledDate: (time) => {
          if (this.ruleForm.activityStartTime) {
            return (
              time.getTime() < Date.now() - 8.64e7 ||
              time.getTime() <
                new Date(this.ruleForm.activityStartTime).valueOf()
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      levelList: [],
      disableTime: false,
      clickActual: true,
      qrcode: null,
      order: "",
      showDialog: false,
      testInfo: [], //动态添加完善信息
      momentValue: {}, //编辑回显
      isShow: false,
      prizeSettingList: {
        price: null,
        title: "",
        assetsId: null,
        prizeType: null,
        logo: "",
        price: "",
        singleAmount: "",
      },
      //时间限制
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.ruleForm.activityStartTime) {
            return (
              time.getTime() <
              new Date(this.ruleForm.activityStartTime).getTime()
            );
          } else {
          }
        },
      },
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.ruleForm.activityEndTime) {
            return (
              time.getTime() > new Date(this.ruleForm.activityEndTime).getTime()
            );
          } else {
          }
        },
      },
      //每日签到
      checked: false,
      joinBlackList: false,
      draggingId: [], //有拖拽时要传的ID顺序
      saveValue: [],
      mainImagelist: [], //图片拖拽排序
      isDragging: false,
      itemListFor: [], //商品弹框选择商品数据
      selectGoodsState: false, //曝光商品弹窗
      selectGoodsArr: [],
      selectGoodsArr2: [],
      ele: "", //点击保存添加一行
      timeDay: 0, //活动持续天数
      timeOut: 0, //多少小时
      limit: true,
      itemArr: [
        {
          continueSignPoints: "",
          days: "",
        },
      ],
      itemArrOne: [],
      localStep: 0,
      localStepNum: this.activityData.id,
      activityStartTime: null,
      activityEndTime: null,
      putPrize: {},
      ruleForm: {
        firstOpenCardTimeType: 0, // 首次入会时间类型
        openCardBeforeDay: "", // 参与活动前N天
        //设置规则表单
        activityName: "",
        partner: ["-1"],
        isFollow: false,
        prizeSet: [],
        inputprize: "",
        exposureSwitch: false,
        radio: 0,
        startTime: "",
        prizeSite: "",
        information: [],
        activityStartTime: null, //活动开始时间
        activityEndTime: null, //活动结束时间peopleCount
        singScore: null,
        activityRulesText: "", //生成规则
        bonusPoints: "", //活动名称，关注店铺有礼奖品设置积分
        peopleCount: "", //邀请开卡
        inviteNum: "",
        prizeSetOne: false,
        prizeCount: null,
        informationOne: [],
        isCumulativePrize: 0,
        shareTitle: "", // 分享标题
        shareIntroduce: "", // 分享简介
        sharePic: "", // 分享图片
        inviteRule: 0, // 被邀请人过滤规则
        filterRule: 0,
        orderTimeType: 1, // 1相对时间 2绝对时间
        dayNum: "",
        orderStartTime: "",
        orderEndTime: "",
        popOrderStartPaymentType: 0,
        orderStartPayment: "",
        itemStartCount: "",
        skuType: 0,
        skuIds: [],
        selectGoodsSkuList: [],
        isValidBlackList: 0,
      },
      goodsLimit: 100,
      goodsState: false,
      selectGoodsSkuList: [],
      startTimeOption: {
        disabledDate: (date) => {
          let endTime = this.ruleForm.orderEndTime;
          let time = date.getTime();
          let isDisabled = false;
          if (endTime) {
            isDisabled =
              time + 24 * 60 * 60 * 1000 >= new Date(endTime).getTime();
            isDisabled =
              isDisabled ||
              time < new Date(endTime).getTime() - 90 * 24 * 60 * 60 * 1000;
          }
          return isDisabled;
        },
      },
      endTimeOption: {
        disabledDate: (date) => {
          let startTime = this.ruleForm.orderStartTime;
          let time = date.getTime();
          let isDisabled = false;
          if (startTime) {
            isDisabled =
              time <= new Date(startTime).getTime() - 24 * 60 * 60 * 1000;
            isDisabled =
              isDisabled ||
              time > new Date(startTime).getTime() + 90 * 24 * 60 * 60 * 1000;
          }
          return isDisabled;
        },
      },
      sharePic: "",
      tableData: [
        {
          peopleCount: "",
          prizeType: "",
          price: "",
          prizeCount: "",
          singleAmount: "",
          title: "",
        },
      ],
      taskTableData: [
        {
          peopleCount: "",
          prizeType: "",
          price: "",
          prizeCount: "",
          singleAmount: "",
          title: "",
        },
      ],
      tableIndex: null,
      taskTableIndex: null,
      rules: {
        // 表单规则校验
        activityName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          {
            min: 3,
            max: 15,
            message: "长度在 3 到 25 个字符",
            trigger: "blur",
          },
        ],
        isLongTime: [
          { required: true, message: "请选择活动时间", trigger: "change" },
        ],
        activityRulesText: [
          { required: true, message: "请填写活动规则", trigger: "blur" },
        ],
        partner: [
          {
            type: "array",
            required: true,
            message: "至少选择一个",
            trigger: "change",
          },
        ],
        prizeSet: [
          {
            type: "array",
            required: true,
            message: " ",
            trigger: "change",
          },
        ],
        startTime: [{ required: true, message: "请选择开始时间" }],
        choosePrize: [{ required: true, message: "请选择奖品" }],
        prizeCount: [{ required: true, message: "请输入奖品数量" }],
        prizeSite: [{ required: true, message: " ", trigger: "blur" }],
        information: [{ required: true, message: " " }],
      },
      isStart: false, // 活动是否已开始
      isDraft: false,
      toAddItem: null,
      isShowAddNum: false,
      toAddBelong: "",
      toAddIndex: 0,
    };
  },
  watch: {
    localStepNum(newVal) {
      if (newVal == 0) {
        this.$nextTick(() => {
          this.$refs.queryId &&
            this.qrcodeAll(this.activityData.telCode, this.$refs.queryId);
        });
      } else {
        this.buriedPoint(1, this.activityData.name, "互动管理", "互动活动");
      }
    },
  },
  // computed: {
  //   // 1: 京获客旗舰版
  //   softType() {
  //     return this.$store.getters.loginUserInfo.yunZhouOtherType || '';
  //   },
  // },
  methods: {
    handleInvite() {
      this.ruleForm.orderTimeType = 1;
      this.ruleForm.dayNum = "";
      this.ruleForm.orderStartTime = "";
      this.ruleForm.orderEndTime = "";
      this.ruleForm.orderStartPayment = "";
      this.ruleForm.itemStartCount = "";
      this.ruleForm.skuType = 0;
      this.selectGoodsSkuList = [];
      this.ruleForm.selectGoodsSkuList = [];
      this.ruleForm.skuIds = [];
    },
    limitInput(event) {
      var value = event.target.value;
      if (value == "0") {
        event.target.value = "";
      } else if (value >= 30) {
        event.target.value = 30;
      } else {
        event.target.value = value.replace(/[^\d]/g, "");
      }
      return event.target.value;
    },
    // 清除效果数据时间
    clearEffectTime() {
      if (this.isStart) return;
      this.ruleForm.orderStartTime = "";
      this.ruleForm.orderEndTime = "";
    },
    // 订单金额
    validateInput(value) {
      // 控制大于0 - 正数可包含小数点
      let newValue = value.replace(/[^0-9.]/g, ""); // 过滤非数字和小数点
      let decimalIndex = newValue.indexOf(".");
      if (decimalIndex !== -1) {
        newValue =
          newValue.slice(0, decimalIndex + 1) +
          newValue.slice(decimalIndex + 1).replace(/\./g, "");
      }
      this.ruleForm.orderStartPayment = newValue.replace(/^0+(\d)/, "$1");
    },
    // 商品件数
    validateInputNew(value) {
      let newValue = value.replace(/[^0-9]/g, ""); // 只允许数字
      if (newValue.length > 0) {
        newValue = newValue.replace(/^0+/, ""); // 移除前导零
        if (newValue === "") {
          newValue = "0";
        }
      }
      if (parseInt(newValue) > 999999) {
        newValue = "999999"; // 设置为最大值
      }

      this.ruleForm.itemStartCount = newValue;
    },
    // 商品弹窗
    showGoods() {
      this.goodsState = true;
      if (this.selectGoodsSkuList.length == 0) {
        this.selectGoodsSkuList = [];
        this.ruleForm.selectGoodsSkuList = [];
      }
      this.$nextTick(() => {
        this.$refs.selectSkuGoods.handleRightCurrentChange(1);
      });
    },
    // 商品组件回调
    skuSelectGoodsChange(val) {
      this.goodsState = false;
      if (val) {
        let valArr = [];
        this.selectGoodsSkuList = val;
        this.ruleForm.selectGoodsSkuList = val;
        val.forEach((i) => {
          valArr.push(i.skuId);
        });
        this.ruleForm.skuIds = valArr;
      }
    },
    filterTypeChange() {
      this.selectGoodsSkuList = [];
      this.ruleForm.selectGoodsSkuList = [];
      this.ruleForm.skuIds = [];
    },
    // 点击活动时间显示提示
    orderFocus() {
      if (this.activityData.isStart) {
        this.isShowTip = true;
      }
    },
    // 改变数量值
    confirmAdd(num) {
      let { toAddBelong, toAddIndex } = this;
      if (toAddBelong == "awardSettingsLsit") {
        this[toAddBelong][toAddIndex].totalAmount = num;
      } else {
        this[toAddBelong][toAddIndex].prizeCount = num;
      }
      this.isShowAddNum = false;
    },
    // 获取相关数据打开弹窗
    itemAddNum(arrStr, index) {
      if (arrStr == "awardSettingsLsit") {
        this.toAddItem = {
          ...this[arrStr][index],
          num: this[arrStr][index].totalAmount,
        };
      } else {
        this.toAddItem = {
          ...this[arrStr][index],
          num: this[arrStr][index].prizeCount,
        };
      }
      if (!this.toAddItem.title) {
        this.$message.error("没有奖品不能设置数量！");
        return;
      }
      this.toAddBelong = arrStr;
      this.toAddIndex = index;
      this.isShowAddNum = true;
    },
    // 1.14迭代
    clearNewTime() {
      this.ruleDto.openCardStartTime = "";
      this.ruleDto.openCardEndTime = "";
    },

    // 打开选择人群
    openCrowd() {
      this.peopleList = this.peopleSelected.map((item) => {
        return { id: item };
      });
      this.selectPeopleShow = true;
      this.actMember = "3";
    },
    // 选择人群关闭
    selectPeopleSure(val) {
      this.peopleSelected = val.map((item) => item.id);
      this.selectPeopleShow = false;
    },
    // 京东计划数量计算
    prizeNum(row, type = 1) {
      console.log(row);
      // 京豆计划已在其他函数判断，这里只计算 京东E卡、plus、爱奇艺、红包
      if ([5, 6, 7, 8, 10].includes(Number(row.prizeType))) {
        if (type == 1) {
          if (
            Number(row.totalAmount) &&
            Number(row.totalAmount) > row.budgetRemain
          ) {
            row.totalAmount = "";
            if (row.prizeType == 5)
              this.$message.error(
                "京东E卡总份额数量不能大于该京东E卡剩余预算额！"
              );
            if (row.prizeType == 6)
              this.$message.error(
                "爱奇艺会员总份额数量不能大于该爱奇艺会员剩余预算额！"
              );
            if (row.prizeType == 7)
              this.$message.error(
                "京东PLUS会员总份额数量不能大于该京东PLUS会员剩余预算额！"
              );
            if (row.prizeType == 8)
              this.$message.error(
                "现金红包总份额数量不能大于该现金红包剩余预算额！"
              );
            if (row.prizeType == 10)
              this.$message.error(
                "礼品卡总份额数量不能大于该礼品卡剩余预算额！"
              );
          }
        } else {
          if (
            Number(row.prizeCount) &&
            Number(row.prizeCount) > row.budgetRemain
          ) {
            row.prizeCount = "";
            if (row.prizeType == 5)
              this.$message.error(
                "京东E卡总份额数量不能大于该京东E卡剩余预算额！"
              );
            if (row.prizeType == 6)
              this.$message.error(
                "爱奇艺会员总份额数量不能大于该爱奇艺会员剩余预算额！"
              );
            if (row.prizeType == 7)
              this.$message.error(
                "京东PLUS会员总份额数量不能大于该京东PLUS会员剩余预算额！"
              );
            if (row.prizeType == 8)
              this.$message.error(
                "现金红包总份额数量不能大于该现金红包剩余预算额！"
              );
            if (row.prizeType == 9)
              this.$message.error(
                "礼品卡总份额数量不能大于该礼品卡剩余预算额！"
              );
          }
        }
      }
    },
    // 活动进行中修改奖品数量
    beAdd(row, type = 1) {
      console.log(row);
      if (this.isStart) {
        if (type == 1) {
          if (row.totalAmount < row.minNum && row.minNum) {
            row.totalAmount = row.minNum;
            this.$message.warning("为避免客诉，奖品数量不能小于之前哦~");
          }
        } else {
          if (row.prizeCount < row.minNum && row.minNum) {
            row.prizeCount = row.minNum;
            this.$message.warning("为避免客诉，奖品数量不能小于之前哦~");
          }
        }
      }
    },
    //上传图片前校验   分享设置
    beforeUpload1(file) {
      let _this = this;
      let image = new Image();
      let _URL = window.URL || window.webkitURL;
      image.onload = function () {
        const valid = image.width == 200 && image.height == 200;
        file.isFlag = valid;
        _this.uploadSize = valid;
        console.log(valid);
        if (valid) {
        } else {
          _this.$message.info("图片宽高不符合要求,请重新上传");
          sizetype = false;
          return false;
        }
      };
      image.src = _URL.createObjectURL(file);
      console.log(file);
      const isLt3M = file.size < 1024 * 1024;

      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg"];
      let sizetype = false;
      if (!isLt3M) {
        this.$message.info("上传图片大小不能超过 1MB");
        return false;
      }
      if (sorts.indexOf(type) < 0) {
        this.$message.info("所选文件格式不符，请重新选择");
        return false;
      }
    },
    // 上传成功  分享设置
    handleUpload1(res) {
      if (res.code != 1) {
        this.$message.error(res.message);
      } else {
        console.log(this.uploadSize);
        if (this.uploadSize) {
          this.ruleForm.sharePic = res.data;
          // console.log(this.ruleForm.sharePic);
        }
      }
    },
    // 重置背景图  分享设置
    picUrlReset1() {
      if (this.isStart) return;
      this.ruleForm.sharePic = this.sharePic;
    },
    indexMethod(index) {
      return "任务" + this.$toChinesNum(index + 1);
    },

    /**
     * 每邀请人数输入框失焦校验
     * 校验：后边的最多邀请人数不能比前边的每邀请人数大
     */
    inviteNumBlur() {
      if (
        this.ruleForm.inviteNum &&
        this.ruleForm.peopleCount &&
        Number(this.ruleForm.peopleCount) <= Number(this.ruleForm.inviteNum)
      ) {
        this.$message.warning("活动期间最多邀请人数不能小于等于每邀请人数");
        // this.ruleForm.peopleCount = "";
      }
    },

    /**
     * 活动最多邀请人数输入框失焦校验
     * 校验：后边的最多邀请人数不能比前边的每邀请人数大
     */
    peopleCountBlur() {
      if (
        this.ruleForm.inviteNum &&
        this.ruleForm.peopleCount &&
        Number(this.ruleForm.peopleCount) <= Number(this.ruleForm.inviteNum)
      ) {
        this.$message.warning("活动期间最多邀请人数不能小于等于每邀请人数");
        // this.ruleForm.peopleCount = "";
      }
    },

    handleCheckputn(e, num = "-1", type = "nojingdou") {
      if (type == "nojingdou") {
        let filtered = e.target.value.replace(/^0|[^\d]/g, "");
        e.target.value = Number(filtered);
        if (num == "0") {
          if (e.target.value < 1) {
            e.target.value = "";
          }
        }
        if (num == "1") {
          if (e.target.value > 9) {
            e.target.value = "";
          }
          if (this.ruleForm.imgNum == 9) {
            this.ruleForm.videoNum = "";
          }
        }
        if (num == "2") {
          if (e.target.value > 1) {
            e.target.value = "";
          }
        }
        if (num == "5") {
          if (e.target.value < 2 || e.target.value > 5) {
            e.target.value = "";
          }
        }
      } else {
        console.log(num, 12);
        if (
          num.quantityTotal &&
          num.price &&
          num.totalAmount &&
          num.prizeType == 2
        ) {
          let numTotal = this.$jingdouTotal({
            ...num,
            prizeCount: num.totalAmount,
          });
          if (!numTotal) {
            this.$message.warning("京豆总份额数量不能大于该京豆预算额！");
          }
          return numTotal;
        } else {
          return num.totalAmount;
        }
      }
    },
    // 红包雨  弹框
    getTheDataAward(data, prizeType) {
      if (prizeType == 1) {
        this.awardSettingsLsit[this.awardIndex].couponType = data.couponType;
        this.awardSettingsLsit[this.awardIndex].singleAmount = 1;
        this.awardSettingsLsit[this.awardIndex].quota = data.quota;
      }
      if (prizeType == 2) {
        this.awardSettingsLsit[this.awardIndex].quantityTotal =
          data.quantityTotal;
      }
      if (prizeType == 3) {
        if (!data.isGoodManage) {
          this.awardSettingsLsit[this.awardIndex].skuId = data.skuId;
          delete this.awardSettingsLsit[this.awardIndex].isGoodManage;
        } else {
          this.awardSettingsLsit[this.awardIndex].isGoodManage =
            data.isGoodManage;
        }
        this.awardSettingsLsit[this.awardIndex].isFollowActivityEndTime = data.isFollowActivityEndTime;
        this.awardSettingsLsit[this.awardIndex].addressFillEndTime = data.addressFillEndTime;
        this.awardSettingsLsit[this.awardIndex].predictSendTime = data.predictSendTime;
        this.awardSettingsLsit[this.awardIndex].shouldCollectExtraData = data.shouldCollectExtraData; //是否需要额外信息
        this.awardSettingsLsit[this.awardIndex].extraQuestion = data.extraQuestion; //额外问题
        this.awardSettingsLsit[this.awardIndex].addressFillLimit = data.addressFillLimit;
        this.awardSettingsLsit[this.awardIndex].commitAddressLimit = data.commitAddressLimit;
      }
      if (data.giftType) {
        this.awardSettingsLsit[this.awardIndex].giftType = Number(
          data.giftType
        );
      }
      this.awardSettingsLsit[this.awardIndex].price =
        data.discount || data.singleAmount;

      this.awardSettingsLsit[this.awardIndex].assetsId = Number(data.couponId || data.skuId);
      this.awardSettingsLsit[this.awardIndex].logo = data.logo;
      this.awardSettingsLsit[this.awardIndex].prizeType = prizeType;
      if (prizeType == 4) {
        this.awardSettingsLsit[this.awardIndex].title =
          data.discount + "店铺积分";
      } else {
        this.awardSettingsLsit[this.awardIndex].title =
          data.name.length >= 12 ? data.name.substring(0, 12) : data.name;
      }
      if (data.singleAmount) {
        this.awardSettingsLsit[this.awardIndex].singleAmount =
          data.singleAmount;
      }
      // 实物随单发
      if(prizeType == 14 || prizeType == 1) {
        this.getPhysicalShipped(this.awardSettingsLsit[this.awardIndex],prizeType,data);
      }
      // 金豆、E卡、爱奇艺、PLUS、红包计划需要剩余份额
      if ([2, 5, 6, 7, 8, 10].includes(prizeType)) {
        this.awardSettingsLsit[this.awardIndex].budgetRemain =
          data.budgetRemain;
      }
      if (prizeType == 3 && data.isGoodManage) {
        this.awardSettingsLsit[this.awardIndex].budgetRemain =
          data.budgetRemain;
      }
      this.showSelectProductAward = false;
    },
    // 红包雨
    selectPacket(index, item) {
      if (this.isStart) return;
      this.itemArr = [];
      this.showSelectProductAward = true;
      this.$nextTick(() => {
        this.$refs.selectProductAward.openDialog();
      });
      this.JingdouCount.prizeCount = item.totalAmount;
      this.awardIndex = index;
      this.echoDate = item;
      console.log(item, 111);
    },
    limitInput(e) {
      let filtered = e.target.value.replace(/[^\d]/g, "");
      e.target.value = filtered;
      if (e.target.value < 1) {
        e.target.value = "";
        this.ruleForm.dayNum = "";
      }
      if (e.target.value > 30) {
        e.target.value = 30;
        this.ruleForm.dayNum = 30;
      }
    },
    itemDel(index) {
      if (this.ruleForm.isCumulativePrize == 1) {
        if (this.tableData.length == 1) {
          this.$message.warning("梯度奖品必须有一个奖项");
          return;
        }
        this.tableData.splice(index, 1);
      } else if (this.ruleForm.isCumulativePrize == 2) {
        if (this.taskTableData.length == 1) {
          this.$message.warning("任务奖品必须有一个奖项");
          return;
        }
        this.taskTableData.splice(index, 1);
      }
    },
    addPrizeRule() {
      if (this.ruleForm.isCumulativePrize == 1) {
        this.tableData.push({
          peopleCount: "",
          prizeType: "",
          value: "",
          prizeCount: "",
          title: "",
        });
      } else {
        this.taskTableData.push({
          peopleCount: "",
          prizeType: "",
          value: "",
          prizeCount: "",
          title: "",
        });
      }
    },
    colseDialog() {
      this.showDialog = false;
      this.clickActual = true;
    },
    //会员等级
    getLevel() {
      querymemberLevel()
        .then((res) => {
          console.log(res, 6667);
          res.data.forEach((item) => {
            this.levelList.push(item.customerLevelName);
          });
          console.log(this.levelList, 111112);
        })
        .catch((res) => {});
    },
    //生成二维码
    qrcodeAll(val, queryId) {
      this.qrcode = new QRCode(queryId, {
        width: 140, // 设置宽度，单位像素
        height: 140, // 设置高度，单位像素
        text: val, // 设置二维码内容或跳转地址
      });
    },
    checkputn(e) {
      let filtered = e.target.value.replace(/^0|[^\d]/g, "");
      e.target.value = Number(filtered);
      console.log(filtered, e.target.value, this.ruleForm.peopleCount);
      // //下边写用户输入时需要的执行逻辑
      // if(this.ruleForm.inputprize!= filtered) {
      //     this.ruleForm.inputprize = filtered
      // }
      // 不能输入0，绑定的值如果小于1，那么输入框置空
      if (e.target.value < 1) {
        e.target.value = "";
      }
    },
    //清空商品数据
    deleteCoupon() {
      this.prizeSettingList.price = null;
      this.prizeSettingList.title = "";
      this.prizeSettingList.assetsId = null;
      this.prizeSettingList.prizeType = null;
    },
    //选择商品数据
    getTheData(data, prizeType) {
      this.colseDialog();
      this.showDialog = false;

      // v3.4邀请开卡
      /**
       * @param singleAmount 积分数，京豆数  其余奖项为1
       */
      // 梯度奖励
      // if (this.ruleForm.isCumulativePrize == true) {
      // this.tableData[this.tableIndex].prizeType = prizeType;
      // this.tableData[this.tableIndex].price = data.discount || data.singleAmount;
      // this.tableData[this.tableIndex].singleAmount = data.singleAmount;
      // this.tableData[this.tableIndex].title = data.name || prizeType;
      // this.tableData[this.tableIndex].assetsId = Number(data.couponId);
      // this.tableData[this.tableIndex].logo = data.logo;
      // if (prizeType == 2) {
      //   this.tableData[this.tableIndex].quantityTotal = data.quantityTotal;
      // }
      if (this.ruleForm.isCumulativePrize == 1) {
        if (prizeType == 1) {
          this.tableData[this.tableIndex].couponType = data.couponType;
          this.tableData[this.tableIndex].singleAmount = 1;
          this.tableData[this.tableIndex].quota = data.quota;
        }
        if (prizeType == 2) {
          this.tableData[this.tableIndex].quantityTotal = data.quantityTotal;
        }
        if (prizeType == 3) {
          this.tableData[this.tableIndex].addressFillEndTime = data.addressFillEndTime
          this.tableData[this.tableIndex].predictSendTime = data.predictSendTime
          this.tableData[this.tableIndex].isFollowActivityEndTime = data.isFollowActivityEndTime
          this.tableData[this.tableIndex].shouldCollectExtraData = data.shouldCollectExtraData
          this.tableData[this.tableIndex].extraQuestion = data.extraQuestion
          this.tableData[this.tableIndex].addressFillLimit = data.addressFillLimit;
          this.tableData[this.tableIndex].commitAddressLimit = data.commitAddressLimit;
          if (!data.isGoodManage) {
            this.tableData[this.tableIndex].skuId = data.skuId;
            delete this.tableData[this.tableIndex].isGoodManage;
          } else {
            this.tableData[this.tableIndex].isGoodManage = data.isGoodManage;
          }
        }
        if (data.giftType) {
          this.tableData[this.tableIndex].giftType = Number(data.giftType);
        }
        this.tableData[this.tableIndex].price =
          data.discount || data.singleAmount;

        this.tableData[this.tableIndex].assetsId = Number(data.couponId || data.skuId);
        this.tableData[this.tableIndex].logo = data.logo;
        this.tableData[this.tableIndex].prizeType = prizeType;
        if (prizeType == 4) {
          this.tableData[this.tableIndex].title = data.discount + "店铺积分";
        } else {
          this.tableData[this.tableIndex].title =
            data.name.length >= 12 ? data.name.substring(0, 12) : data.name;
        }
        if (data.singleAmount) {
          this.tableData[this.tableIndex].singleAmount = data.singleAmount;
        }
        // 实物随单发
        if(prizeType == 14 || prizeType == 1) {
          this.getPhysicalShipped(this.tableData[this.tableIndex],prizeType,data);
        }
        // 金豆、E卡、爱奇艺、PLUS、红包计划需要剩余份额
        if ([2, 5, 6, 7, 8, 10].includes(Number(prizeType))) {
          this.tableData[this.tableIndex].budgetRemain = data.budgetRemain;
        }
        if (prizeType == 3 && data.isGoodManage) {
          this.tableData[this.tableIndex].budgetRemain = data.budgetRemain;
        }
      } else if (this.ruleForm.isCumulativePrize == 2) {
        if (prizeType == 1) {
          this.taskTableData[this.taskTableIndex].couponType = data.couponType;
          this.taskTableData[this.taskTableIndex].singleAmount = 1;
          this.taskTableData[this.taskTableIndex].quota = data.quota;
        }
        if (prizeType == 2) {
          this.taskTableData[this.taskTableIndex].quantityTotal =
            data.quantityTotal;
        }
        if (prizeType == 3) {
          this.taskTableData[this.taskTableIndex].addressFillEndTime = data.addressFillEndTime
          this.taskTableData[this.taskTableIndex].predictSendTime = data.predictSendTime
          this.taskTableData[this.taskTableIndex].isFollowActivityEndTime = data.isFollowActivityEndTime
          this.taskTableData[this.taskTableIndex].shouldCollectExtraData = data.shouldCollectExtraData
          this.taskTableData[this.taskTableIndex].extraQuestion = data.extraQuestion
          this.taskTableData[this.taskTableIndex].addressFillLimit = data.addressFillLimit;
          this.taskTableData[this.taskTableIndex].commitAddressLimit = data.commitAddressLimit;
          if (!data.isGoodManage) {
            this.taskTableData[this.taskTableIndex].skuId = data.skuId;
            delete this.taskTableData[this.taskTableIndex].isGoodManage;
          } else {
            this.taskTableData[this.taskTableIndex].isGoodManage =
              data.isGoodManage;
          }
        }
        if (data.giftType) {
          this.taskTableData[this.taskTableIndex].giftType = Number(
            data.giftType
          );
        }
        this.taskTableData[this.taskTableIndex].price =
          data.discount || data.singleAmount;

        this.taskTableData[this.taskTableIndex].assetsId = Number(
          data.couponId || data.skuId
        );
        this.taskTableData[this.taskTableIndex].logo = data.logo;
        this.taskTableData[this.taskTableIndex].prizeType = prizeType;
        if (prizeType == 4) {
          this.taskTableData[this.taskTableIndex].title =
            data.discount + "店铺积分";
        } else {
          this.taskTableData[this.taskTableIndex].title =
            data.name.length >= 12 ? data.name.substring(0, 12) : data.name;
        }
        if (data.singleAmount) {
          this.taskTableData[this.taskTableIndex].singleAmount =
            data.singleAmount;
        }
        // 实物随单发
        if(prizeType == 14 || prizeType == 1) {
          this.getPhysicalShipped(this.taskTableData[this.taskTableIndex],prizeType,data);
        }
        // 金豆、E卡、爱奇艺、PLUS、红包计划需要剩余份额
        if ([2, 5, 6, 7, 8, 10].includes(prizeType)) {
          this.taskTableData[this.taskTableIndex].budgetRemain =
            data.budgetRemain;
        }
        if (prizeType == 3 && data.isGoodManage) {
          this.taskTableData[this.taskTableIndex].budgetRemain =
            data.budgetRemain;
        }
      }
    },
    setPrizeTxt(item) {
      if (item.prizeType == 8) {
        item.prizeTxt = item.price + "元";
      } else if (
        item.prizeType == 7 ||
        item.prizeType == 6 ||
        item.prizeType == 5
      ) {
        item.prizeTxt = item.price;
      } else {
        item.prizeTxt = item.singleAmount;
      }
    },
    //模板下一步
    nextStep() {
      this.localStepNum = this.activityData.id;
      this.localStep = 1;
      this.$emit("titopName", this.activityData.name, true);
    },
    // 保存草稿
    saveDraft() {
      //活动名称的限制
      if (
        !this.ruleForm.activityName ||
        this.ruleForm.activityName.length == 0
      ) {
        this.$message.warning("请输入活动名称");
        return;
      }
      if (this.isDraftEdit) {
        this.$confirm("是否保存对当前草稿的修改?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      } else {
        this.$confirm("是否存为草稿?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      }
    },
    //弹框确认
    async handleDialogCloseAnoth() {
      // this.ruleForm.activityStartTime = this.activityTimeValue[0];
      // this.ruleForm.activityEndTime = this.activityTimeValue[1];
      let everyDay = {
        activityName: this.ruleForm.activityName, //活动名称
        // 1.14迭代 这里提交
        allowLevel: this.ruleForm.partner.join(","), //参与会员等级：-1(全部)，0(非会员)，其余填会员等级
        condFollow: this.ruleForm.isFollow == true ? 1 : 0, //参与条件
        endTime: this.ruleForm.activityEndTime, //活动结束时间
        isExposureItem: this.ruleForm.exposureSwitch == false ? 0 : 1, //是否曝光商品：0否,1是
        itemList: this.itemListFor, //曝光商品集合
        points: Number(this.ruleForm.inputprize), //单次奖励积分
        priceType: this.ruleForm.radio, //曝光商品价格显示：0显示京东价，1显示促销价
        pointActivityPrizeDTO: {
          //选择奖品数据
          price: this.prizeSettingList.price,
          title: this.prizeSettingList.title,
          assetsId: this.prizeSettingList.assetsId,
          prizeType: this.prizeSettingList.prizeType,
          logo: this.prizeSettingList.logo,
          couponType: this.prizeSettingList.couponType,
          addressFillEndTime: this.prizeSettingList.addressFillEndTime, //地址填写截止时间
          predictSendTime: this.prizeSettingList.predictSendTime, //预测发货时间
          isFollowActivityEndTime: this.prizeSettingList.isFollowActivityEndTime, //是否跟随活动结束时间
          shouldCollectExtraData: this.prizeSettingList.shouldCollectExtraData, //是否需要额外信息
          extraQuestion: this.prizeSettingList.extraQuestion, //额外问题
        },
        ruleDTO: {
          isCheckOpenCardTime:
            this.actMember == 2 ? this.ruleDto.isCheckOpenCardTime : false,
          openCardStartTime:
            this.actMember == 2 ? this.ruleDto.openCardStartTime : "",
          openCardEndTime:
            this.actMember == 2 ? this.ruleDto.openCardEndTime : "",
          plusObject: this.ruleDto.plusObject, //plus会员
          isForceRemind: this.ruleDto.isForceRemind, //是否强制提醒
          cusTemplateJSON: this.ruleDto.cusTemplateJSON,
          receiveType: this.ruleDto.receiveType,

          //规则拓展信息
          continueRule: this.itemArr,
          requestFollow: this.ruleForm.isFollow, //是否关注
          startTime: this.ruleForm.startTime,
          prizeCount: Number(this.ruleForm.prizeCount),
          shareTitle: this.ruleForm.shareTitle,
          shareIntroduce: this.ruleForm.shareIntroduce,
          sharePic: this.ruleForm.sharePic,
          customerPaperwork: JSON.stringify({...this.customerPaperwork,shopNameType: this.ruleForm.shopNameType,moreActSet: this.ruleForm.moreActSet}),
        },
        ruleDescription: this.ruleForm.activityRulesText, //规则拓展信息
        startTime: this.ruleForm.activityStartTime, //活动开始时间
        isKeyActivity: this.isKeyActivity,
        placementPosition: this.placementPosition.join(","),
        isValidBlackList: this.ruleForm.isValidBlackList, // 是否开启黑名单
        studentStatus: this.ruleForm.studentStatus,
      };
      if (this.actMember == 1) {
        everyDay.allowLevel = "-1";
      } else if (this.actMember == 3) {
        everyDay.allowLevel = "99";
        everyDay.crowdIds = this.peopleSelected.join(",");
      } else if (this.actMember == 2) {
        everyDay.allowLevel = this.ruleForm.partner.join(",");
        if (everyDay.allowLevel == "-1") {
          //会员等级设置
          let list = ["-1", "0"];
          this.levelList.forEach((item, index) => {
            let num = index + 1;
            list.push(num);
          });
          everyDay.allowLevel = list.join(",");
        }
      }
      //编辑回显
      this.momentValue = everyDay;
      //对象排序(根据对象的某一属性)
      if (this.draggingId.length != []) {
        let a = this.draggingId;
        let b = [];
        for (let i = 0; i < a.length; i++) {
          this.itemListFor.find((obj) => {
            // if (obj.wareId == a[i]) {
            //   b.push({
            //     logo: obj.logo,
            //     price: obj.price,
            //     title: obj.title,
            //     wareId: obj.wareId,
            //   });
            // }
            if (obj.skuId == a[i]) {
              b.push({
                logo: obj.logo,
                price: obj.price,
                title: obj.title,
                skuId: obj.skuId,
              });
            }
          });
        }
        everyDay.itemList = b;
      }
      if (!this.isDraft) {
        //活动名称的限制
        if (
          !this.ruleForm.activityName ||
          this.ruleForm.activityName.length == 0
        ) {
          this.$message.warning("请输入活动名称");
          return;
        }
        //活动时间的限制
        if (
          !this.ruleForm.activityStartTime ||
          !this.ruleForm.activityEndTime
        ) {
          this.$message.warning("请输入活动时间");
          return;
        }
        let nowTime = new Date().getTime();
        let end = new Date(this.ruleForm.activityEndTime).valueOf();
        if (end < nowTime) {
          this.$message.warning("结束时间不能小于当前时间");
          return;
        }
        if (this.actMember == "2") {
          if (
            this.ruleForm.firstOpenCardTimeType == 1 &&
            (!this.ruleForm.openCardBeforeDay)
          ) {
            return this.$message.warning("请完善首次入会时间");
          }
          if (
            this.ruleForm.firstOpenCardTimeType == 2 &&
            (!this.ruleDto.openCardStartTime || !this.ruleDto.openCardEndTime)
          ) {
            return this.$message.warning("请完善首次入会时间");
          }
        }
        if (this.ruleForm.inviteRule != 0) {
          if (this.ruleForm.orderTimeType == 1 && !this.ruleForm.dayNum) {
            this.$message.warning("请输入下单时间~");
            return;
          }
          if (
            this.ruleForm.orderTimeType == 2 &&
            (!this.ruleForm.orderStartTime || !this.ruleForm.orderEndTime)
          ) {
            this.$message.warning("请选择下单时间~");
            return;
          }
          if (this.ruleForm.inviteRule == 2) {
            if (
              this.ruleForm.skuType == 1 &&
              this.selectGoodsSkuList.length == 0
            ) {
              this.$message.warning("请勾选指定商品~");
              return;
            } else if (
              this.ruleForm.skuType == 2 &&
              this.selectGoodsSkuList.length == 0
            ) {
              this.$message.warning("请勾选排除商品~");
              return;
            }
          }
        }

        // 1.14迭代 这里判断
        if (this.actMember == "2") {
          if (
            this.ruleDto.isCheckOpenCardTime &&
            (!this.ruleDto.openCardStartTime || !this.ruleDto.openCardEndTime)
          ) {
            return this.$message.warning("请选择入会时间");
          }
        }

        if (this.actMember == 3 && !this.peopleSelected.length) {
          this.$message.warning("请选择指定人群");
          return;
        }
        // 小程序分享标题
        if (!this.ruleForm.shareTitle) {
          this.$message.warning("请输入小程序分享标题");
          return;
        }
        // 小程序分享简介
        if (!this.ruleForm.shareIntroduce) {
          this.$message.warning("请输入小程序分享简介");
          return;
        }
        if (!this.ruleForm.activityRulesText) {
          this.$message.warning("活动规则不能为空");
          return;
        }
      }
      //判断勾选提示后即可调取接口
      if (this.checked == true || this.isDraft) {
        //通过活动来调取不一样的接口
        if (this.activityData.name == "邀请开卡有礼") {
          everyDay.ruleDTO = {
            firstOpenCardTimeType: this.ruleForm.firstOpenCardTimeType,
            openCardBeforeDay: this.ruleForm.openCardBeforeDay,
            isCheckOpenCardTime:
              this.actMember == 2 ? this.ruleDto.isCheckOpenCardTime : false,
            openCardStartTime:
              this.actMember == 2 ? this.ruleDto.openCardStartTime : "",
            openCardEndTime:
              this.actMember == 2 ? this.ruleDto.openCardEndTime : "",
            plusObject: this.ruleDto.plusObject, //plus会员
            isForceRemind: this.ruleDto.isForceRemind, //是否强制提醒
            cusTemplateJSON: this.ruleDto.cusTemplateJSON,
            receiveType: this.ruleDto.receiveType,
            shareTitle: this.ruleForm.shareTitle,
            shareIntroduce: this.ruleForm.shareIntroduce,
            sharePic: this.ruleForm.sharePic,
            inviteRule: this.ruleForm.inviteRule,
            filterRule: this.ruleForm.filterRule,
            orderTimeType: this.ruleForm.orderTimeType,
            dayNum: this.ruleForm.dayNum,
            orderStartTime: this.ruleForm.orderStartTime,
            orderEndTime: this.ruleForm.orderEndTime,
            popOrderStartPaymentType: this.ruleForm.popOrderStartPaymentType,
            orderStartPayment: this.ruleForm.orderStartPayment,
            itemStartCount: this.ruleForm.itemStartCount,
            skuType: this.ruleForm.skuType,
            skuIds: this.ruleForm.skuIds,
            customerPaperwork: JSON.stringify({...this.customerPaperwork,shopNameType: this.ruleForm.shopNameType,moreActSet: this.ruleForm.moreActSet}),
          };
          // 接口需要，points固定传个正数
          everyDay.points = 1;

          everyDay.ruleDTO.maxInviteNum = this.ruleForm.peopleCount;
          everyDay.ruleDTO.inviteNum = this.ruleForm.inviteNum;
          everyDay.ruleDTO.isCumulativePrize =
            this.ruleForm.isCumulativePrize == 1 ? true : false;
          delete everyDay.pointActivityPrizeDTO;
          // 是否任务类型
          everyDay.ruleDTO.isTaskPrize =
            this.ruleForm.isCumulativePrize == 2 ? true : false;
          // 梯度奖励
          if (
            this.ruleForm.isCumulativePrize == 1 ||
            this.ruleForm.isCumulativePrize == 2
          ) {
            everyDay.ruleDTO.cumulativePrizes =
              this.ruleForm.isCumulativePrize == 1
                ? this.tableData.map((item) => {
                    let prize = {
                      ...item,
                      couponType: item.couponType,
                      title: item.title,
                      assetsId: item.assetsId,
                      prizeType: item.prizeType,
                      singleAmount: item.singleAmount,
                      totalAmount: item.prizeCount,
                      price: item.price || item.singleAmount,
                      id: item.id,
                    };
                    if (prize.prizeType == 3 || prize.prizeType == 10) {
                      prize.logo = item.logo;
                    }
                    if (prize.prizeType == 3) {
                      prize.isFollowActivityEndTime = item.isFollowActivityEndTime;
                      prize.predictSendTime = item.predictSendTime;
                      prize.addressFillEndTime = item.addressFillEndTime;
                      prize.shouldCollectExtraData = item.shouldCollectExtraData; //是否需要额外信息
                      prize.extraQuestion = item.extraQuestion; //额外问题
                      prize.addressFillLimit = item.addressFillLimit;
                      // 提交地址限制：数组转逗号分隔字符串
                      prize.commitAddressLimit = Array.isArray(item.commitAddressLimit)
                        ? item.commitAddressLimit.join(',')
                        : item.commitAddressLimit;
                      if (prize.isGoodManage == 1) {
                        prize.isGoodManage = item.isGoodManage;
                      } else {
                        prize.assetsId = item.skuId;
                      }
                    }
                    if (prize.prizeType != 2 && prize.prizeType != 4) {
                      console.log(item.price);
                      prize.price = item.price;
                    }
                    if (prize.prizeType == 2 || prize.prizeType == 4) {
                      prize.singleAmount = item.price;
                    } else {
                      prize.singleAmount = 1;
                    }
                    return {
                      cumulativeNum: item.peopleCount,
                      cumulativePrizeDTO: prize,
                    };
                  })
                : this.taskTableData.map((item) => {
                    let prize = {
                      ...item,
                      couponType: item.couponType,
                      title: item.title,
                      assetsId: item.assetsId,
                      prizeType: item.prizeType,
                      singleAmount: item.singleAmount,
                      totalAmount: item.prizeCount,
                      price: item.price || item.singleAmount,
                      id: item.id,
                    };
                    if (prize.prizeType == 3 || prize.prizeType == 10) {
                      prize.logo = item.logo;
                    }
                    if (prize.prizeType == 3) {
                      prize.isFollowActivityEndTime = item.isFollowActivityEndTime;
                      prize.predictSendTime = item.predictSendTime;
                      prize.addressFillEndTime = item.addressFillEndTime;
                      prize.shouldCollectExtraData = item.shouldCollectExtraData; //是否需要额外信息
                      prize.extraQuestion = item.extraQuestion; //额外问题
                      prize.addressFillLimit = item.addressFillLimit;
                      // 提交地址限制：数组转逗号分隔字符串
                      prize.commitAddressLimit = Array.isArray(item.commitAddressLimit)
                        ? item.commitAddressLimit.join(',')
                        : item.commitAddressLimit;
                      if (prize.isGoodManage == 1) {
                        prize.isGoodManage = item.isGoodManage;
                      } else {
                        prize.assetsId = item.skuId;
                      }
                    }
                    if (prize.prizeType != 2 && prize.prizeType != 4) {
                      console.log(item.price);
                      prize.price = item.price;
                    }
                    if (prize.prizeType == 2 || prize.prizeType == 4) {
                      prize.singleAmount = item.price;
                    } else {
                      prize.singleAmount = 1;
                    }
                    return {
                      cumulativeNum: item.peopleCount,
                      cumulativePrizeDTO: prize,
                    };
                  });
            if (this.ruleForm.isCumulativePrize == 1) {
              everyDay.ruleDTO.maxInviteNum =
                this.tableData[this.tableData.length - 1].peopleCount;
            }
          } else {
            let isflay = false;
            let objSet = this.awardSettingsLsit.map((item, index) => {
              let prize = {
                ...item,
                awardLevel: index + 1,
              };
              if (prize.prizeType == 1) {
                prize.quota = item.quota;
                prize.couponType = item.couponType;
                prize.singleAmount = 1;
              } else if (prize.prizeType == 8) {
                prize.singleAmount = 1;
              } else if (prize.prizeType == 3) {
                prize.isFollowActivityEndTime = item.isFollowActivityEndTime;
                prize.addressFillEndTime = item.addressFillEndTime;
                prize.predictSendTime = item.predictSendTime;
                prize.addressFillLimit = item.addressFillLimit;
                // 提交地址限制：数组转逗号分隔字符串
                prize.commitAddressLimit = Array.isArray(item.commitAddressLimit)
                  ? item.commitAddressLimit.join(',')
                  : item.commitAddressLimit;
                prize.singleAmount = 1;
                if (prize.isGoodManage == 1) {
                  prize.isGoodManage = item.isGoodManage;
                } else {
                  prize.assetsId = item.skuId;
                }
              } else {
                prize.singleAmount = item.price;
              }
              if (!item.prizeType) isflay = true;
              return prize;
            });

            everyDay.ruleDTO.cumulativePrizes = [
              {
                cumulativeNum: 1,
                cumulativePrizeDTO: { ...objSet[0] },
              },
            ];

            if (isflay && !this.isDraft) this.$message.warning("请填写奖品");
          }

          // 编辑
          if (
            this.activeValue == 5 &&
            !this.activityData.isCopy &&
            !this.isDraft &&
            !this.isDraftEdit
          ) {
            everyDay.pointActivityId = this.valueRow.id;
            let res;
            if (this.activityData.isStart) {
              // 进行中活动使用通用接口
              let params = {
                activityId: everyDay.pointActivityId,
                endTime: everyDay.endTime,
                ruleDescription: everyDay.ruleDescription,
                prizes: everyDay.ruleDTO.cumulativePrizes.map((item) => {
                  return {
                    ...item.cumulativePrizeDTO,
                    prizeId: item.cumulativePrizeDTO.id,
                    totalAmount: item.cumulativePrizeDTO.totalAmount,
                    isFollowActivityEndTime: item.cumulativePrizeDTO.isFollowActivityEndTime,
                    addressFillEndTime: item.cumulativePrizeDTO.addressFillEndTime,
                    predictSendTime: item.cumulativePrizeDTO.predictSendTime,
                    addressFillLimit: item.cumulativePrizeDTO.addressFillLimit,
                    title: item.cumulativePrizeDTO.title,
                    shouldCollectExtraData: item.cumulativePrizeDTO.shouldCollectExtraData, //是否需要额外信息
                    extraQuestion: item.cumulativePrizeDTO.extraQuestion, //额外问题
                  };
                }),
                isExposureItem: this.ruleForm.exposureSwitch ? 1 : 0,
                itemList: this.itemListForFilter,
                ruleDTO: everyDay.ruleDTO,
                isValidBlackList: this.ruleForm.isValidBlackList,
              };
              if (this.actEndTime != this.ruleForm.activityEndTime) {
                params.endTime = this.ruleForm.activityEndTime;
              }
              res = await updateCommon(params);
            } else {
              res = await editInvite(everyDay);
            }
            // editInvite(everyDay)
            //   .then((res) => {
            if (res && res.code == 1) {
              // this.$emit("saveEdit");
              this.$router.push({
                name: "throw",
                query: {
                  id: res.data.id,
                  activityType: res.data.activityType,
                },
              });
              this.$message.success(res.message);
            } else {
              if (res.message) {
                this.$message.error(res.message);
              } else {
                this.$message.error(res.data.message);
              }
            }
            // })
            // .catch(() => {});
          } else {
            if (this.isDraft) {
              everyDay.status = 5;
              // 草稿箱奖品填写完整校验-若不全则为空
              everyDay.ruleDTO.cumulativePrizes =
                everyDay.ruleDTO.cumulativePrizes.filter(
                  (item) => item.cumulativePrizeDTO.prizeType
                );
            }
            // 草稿箱编辑-添加活动id
            if (this.isDraftEdit) {
              everyDay.id = this.valueRow.id;
            }
            if(this.activityData.isCopy){
              delete everyDay.id
            }
            invite(everyDay)
              .then((res) => {
                if (res.code == 1) {
                  // this.$emit("saveEdit");
                  if (this.isDraft) {
                    this.$message.success("保存成功！");
                    this.$emit("returnBack", true);
                  } else {
                    this.$router.push({
                      name: "throw",
                      query: {
                        id: res.data.id,
                        activityType: res.data.activityType,
                      },
                    });
                    this.$message.success(res.message);
                  }
                } else {
                  this.$message.error(res.message);
                }
              })
              .catch(() => {});
          }
        }
        this.joinBlackList = false;
        return;
      } else {
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    // 检查奖品总数
    async checkedPrizeCount(item) {
      // const typeArr = ['','','jingdouList','3','4','allAccountList','allAccountList','allAccountList','redPacketList']
      await this.setPromise(item);

      // console.log(res);
      // res.filter(i=>{
      //   if (i==item.priceType) {

      //   }
      // })
    },
    setPromise(item) {
      if (item.priceType == 2) {
        return new Promise((resolve, reject) => {
          const formLitJD = {
            current: 1,
            size: 100,
            isFilterUsed: true,
            status: 2,
          };
          jingdouList(formLitJD)
            .then((res) => {
              res.filter((i) => {
                // 对应的计划
                if (i.id == item.assetsId) {
                  // 奖品总份数为空
                  if (!item.totalAmount) {
                  }
                }
              });
              resolve(res);
            })
            .catch((res) => {});
        });
      }
    },
    // getJingdouList() {
    //   jingdouList(this.formLitJD)
    //     .then((res) => {
    //       let selectArr = res.data.records.map((item) => {
    //         return {
    //           label: item.planName,
    //           value: item.id,
    //         };
    //       });
    //       this.selectList = selectArr;
    //       this.planList.jingdou = res.data.records
    //     })
    //     .catch((res) => {});
    // },
    //时间
    clearTime(a, b) {
      this.ruleForm.activityStartTime = "";
      this.ruleForm.activityEndTime = "";
    },
    //删除
    delec(index) {
      this.mainImagelist.splice(index, 1);
      this.itemListFor.splice(index, 1);
      // console.log(this.selectGoodsArr, 4444444);
    },
    //完善信息删除
    deleteaInfo(index) {
      this.itemArrOne.splice(index, 1);
    },
    //图片拖拽
    onEnd() {
      this.isDragging = false;
      //拖拽完成后的顺序
      let arr = [];
      this.mainImagelist.forEach((item) => {
        // arr.push(item.wareId);
        arr.push(item.skuId);
        this.draggingId = arr;
      });
    },
    //商品回调
    selectGoodsChange(val) {
      this.goodsState = false;
    },
    centerVis(scope) {
      if (this.isStart) return;
      this.itemArr = this.tableData;
      console.log(scope.$index);
      this.echoDate = scope.row;
      // 梯度奖品
      if (scope.$index || scope.$index == 0) {
        if (this.ruleForm.isCumulativePrize == 1) {
          this.tableIndex = scope.$index;
          // 点击到已选实物奖品的条件，不置灰实物tab
          if (this.tableData[scope.$index].prizeType == 3) {
            this.clickActual = false;
          }
        } else if (this.ruleForm.isCumulativePrize == 2) {
          this.taskTableIndex = scope.$index;
          // 点击到已选实物奖品的条件，不置灰实物tab
          if (this.taskTableData[scope.$index].prizeType == 3) {
            this.clickActual = false;
          }
        }
      }

      if (this.isCumulativePrize) {
        this.putPrize = this.tableData[this.tableIndex];
      } else {
        this.putPrize = this.prizeSettingList;
      }
      this.showDialog = true;
      this.$nextTick(() => {
        this.$refs.selectProduct.openDialog();
      });
    },
    //连续签到送积分
    signInpoints(val) {
      this.ruleForm.singScore = val;
    },
    //连续签到删除
    deletea(index) {
      this.itemArr.splice(index, 1);
    },
    //添加条件
    addCondition() {
      let parm = {
        continueSignPoints: this.itemArr.continueSignPoints,
        days: this.itemArr.days,
      };
      this.ele++;
      this.ele = parm;
      this.itemArr.push(this.ele);
    },
    //完善信息的添加
    perfectAdd() {
      let valueParm = {
        informationmation: this.itemArrOne.informationmation,
        informationmationOne: this.itemArrOne.informationmationOne,
      };
      this.element++;
      this.element = valueParm;
      this.itemArrOne.push(this.element);
    },
    //奖品设置
    prizeSetChange(val) {
      if (val == true) {
        this.limit = false;
      } else {
        this.limit = true;
        this.ruleForm.inputprize = "";
      }
    },
    //活动时间驱动
    activityTimeChange(val) {
      // this.ruleForm.activityStartTime = this.activityTimeValue[0];
      // this.ruleForm.activityEndTime = this.activityTimeValue[1];
      // 校验有无时间
      if (!this.ruleForm.activityStartTime || !this.ruleForm.activityEndTime)
        return;
      let nowTime = new Date().getTime();
      let start = new Date(this.ruleForm.activityStartTime).valueOf();
      let end = new Date(this.ruleForm.activityEndTime).valueOf();
      let invalidateDate = new Date(
        this.$store.getters.pointUserInfo.expiredIn
      ).valueOf();
      let hdInvalidateDate = new Date(
        this.$store.getters.loginUserInfo.expiresIn
      ).valueOf();
      if (this.backgroundOpacity) {
        var datas, change1, change2, days, daysStart, daysEnd, date3;
        // daysStart = this.ruleForm.activityStartTime.substring(0, 10);
        // daysEnd = this.ruleForm.activityEndTime.substring(0, 10);
        if (
          this.ruleForm.activityEndTime != "" &&
          this.ruleForm.activityStartTime != ""
        ) {
          // datas = daysEnd.split("-");
          // change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
          // datas = daysStart.split("-");
          // change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
          // days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);
          // this.timeDay = days;

          // 更换组件后需要更换时间计算方法
          this.timeDay = Math.floor(
            Math.abs(
              new Date(this.ruleForm.activityEndTime) -
                new Date(this.ruleForm.activityStartTime)
            ) /
              1000 /
              60 /
              60 /
              24
          );

          //计算小时
          date3 =
            new Date(this.ruleForm.activityEndTime).getTime() -
            new Date(this.ruleForm.activityStartTime).getTime();
          var leave1 = date3 % (24 * 3600 * 1000);
          this.timeOut = Math.floor(leave1 / (3600 * 1000));
        } else {
          this.timeOut = 0;
          return;
        }
        return;
      }
      if (end > invalidateDate) {
        this.$message.warning("活动时间不可超过互动数据授权有效期！");
        // this.activityTimeValue[1] = "";
        this.ruleForm.activityEndTime = "";
        return;
      }
      if (end > hdInvalidateDate) {
        this.$message.warning("活动时间不可超过互动数据授权有效期！");
        // this.activityTimeValue[1] = "";
        this.ruleForm.activityEndTime = "";
        return;
      }
      if (start < nowTime) {
        if (this.activeValue) {
          this.disableTime = true;
        }
      }
      if (end < nowTime) {
        this.$message.warning("结束时间不能小于当前时间");
        // return;
      }
      if (end < start) {
        this.$message.warning("结束时间不能小于开始时间");
        return;
      }
      var datas, change1, change2, days, daysStart, daysEnd, date3;
      // daysStart = this.ruleForm.activityStartTime.substring(0, 10);
      // daysEnd = this.ruleForm.activityEndTime.substring(0, 10);
      if (
        this.ruleForm.activityEndTime != "" &&
        this.ruleForm.activityStartTime != ""
      ) {
        // datas = daysEnd.split("-");
        // change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        // datas = daysStart.split("-");
        // change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        // days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);
        // this.timeDay = days;

        // 更换组件后需要更换时间计算方法
        this.timeDay = Math.floor(
          Math.abs(
            new Date(this.ruleForm.activityEndTime) -
              new Date(this.ruleForm.activityStartTime)
          ) /
            1000 /
            60 /
            60 /
            24
        );

        //计算小时
        date3 =
          new Date(this.ruleForm.activityEndTime).getTime() -
          new Date(this.ruleForm.activityStartTime).getTime();
        var leave1 = date3 % (24 * 3600 * 1000);
        this.timeOut = Math.floor(leave1 / (3600 * 1000));
      } else {
        this.timeOut = 0;
        return;
      }
      if (
        this.ruleForm.activityEndTime &&
        this.ruleForm.activityStartTime &&
        this.ruleForm.activityEndTime.substring(0, 10) ==
          this.ruleForm.activityStartTime.substring(0, 10)
      ) {
        this.$message.warning("活动时间不能小于一天");
        // this.activityTimeValue[1] = "";
        this.ruleForm.activityEndTime = "";
      }
    },
    // 返回上一步
    returnBack() {
      if (this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      if (this.localStep == 0) this.$emit("returnBack");
      if (this.localStep == 1) {
        this.localStep = 0;
        this.localStepNum = 0;
      }
    },
    // 取消编辑
    cancelEdit() {
      this.$emit("cancelEdit");
    },
    //保存编辑
    saveEdit() {
      // 统一奖品模式校验：最多邀请人数不能小于等于每邀请人数
      if (this.ruleForm.isCumulativePrize == 0) {
        if (
          this.ruleForm.inviteNum &&
          this.ruleForm.peopleCount &&
          Number(this.ruleForm.peopleCount) <= Number(this.ruleForm.inviteNum)
        ) {
          return this.$message.warning("活动期间最多邀请人数不能小于等于每邀请人数");
        }
      }
      let state = true;
      if (this.ruleForm.isCumulativePrize == 1) {
        let arr = this.tableData.map((i) => {
          return i.peopleCount;
        });
        if (arr.indexOf("") != -1) {
          return this.$message.error("邀请人数不可为空");
        }
        var flagSort = false;
        for (let i = 0; i < arr.length; i++) {
          if (arr[i + 1]) {
            if (Number(arr[i]) >= Number(arr[i + 1])) {
              flagSort = true;
              break;
            }
          }
        }
        if (flagSort) {
          return this.$message.error("邀请人数梯度不可小于或等于上一个梯度");
        }

        for (let index = 0; index < arr.length; index++) {
          const element = arr[index];
          if (this.tableData[index].prizeType == "") {
            return this.$message.error("请在条件中设置奖品");
          }
          if (this.tableData[index].prizeCount == "") {
            return this.$message.error("请在条件中设置奖品数量");
          }
          for (
            let indexSecond = index;
            indexSecond < arr.length;
            indexSecond++
          ) {
            console.log(element, arr[indexSecond], element > arr[indexSecond]);
            if (Number(element) > Number(arr[indexSecond])) {
              state = false;
            }
          }
        }
        if (!state) {
          return this.$message.error("邀请人数梯度不可小于上一个梯度");
        }
      } else if (this.ruleForm.isCumulativePrize == 2) {
        let arr = this.taskTableData.map((i) => {
          return i.peopleCount;
        });
        if (arr.indexOf("") != -1) {
          return this.$message.error("邀请人数不可为空");
        }

        for (let index = 0; index < arr.length; index++) {
          const element = arr[index];
          if (this.taskTableData[index].prizeType == "") {
            return this.$message.error("请在条件中设置奖品");
          }
          if (this.taskTableData[index].prizeCount == "") {
            return this.$message.error("请在条件中设置奖品数量");
          }
        }
      } else if (
        this.ruleForm.isCumulativePrize == 0 &&
        this.activityData.name == "邀请开卡有礼"
      ) {
        if (!this.ruleForm.peopleCount || !this.ruleForm.inviteNum) {
          return this.$message.error("请输入邀请人数");
        }
        let title = this.awardSettingsLsit.map((i) => {
          return i.title;
        });
        if (!title[0]) {
          return this.$message.error("请在条件中设置奖品");
        }
        let arr = this.awardSettingsLsit.map((i) => {
          return i.totalAmount;
        });
        if (!arr[0]) {
          return this.$message.error("请在条件中设置奖品数量");
        }
      }
      // 公活动配置校验
      this.customerPaperwork = { ...this.customerPaperwork,moreActSet: this.ruleForm.moreActSet}
      if (!useValidateMoreActSet(this)) {
        return;
      }
      if(this.placementPosition.length==0) {    
        this.$message.warning("请选择活动投放位置！");
        return
      }

      this.joinBlackList = true;
    },
    // 下一步
    resetForm() {
      this.joinBlackList = true;
    },
    //添加曝光商品弹窗
    exposureProducts() {
      this.selectGoodsState = true;
      // console.log(this.itemListFor);
      if (this.itemListFor.length == 0) {
        this.itemListFor = [];
        this.mainImagelist = [];
        this.selectGoodsArr = [];
      }
      // debugger
      this.$refs.selectGo.handleRightCurrentChange(1);
      // console.log(this.selectGoodsArr);
      // return
    },
    selectGoodsSure(data) {
      if (!data) {
        this.selectGoodsState = false;
        return;
      }
    },
    selectGoodsClose(data) {
      console.log(data);
      // debugger
      if (data) {
        console.log(data);
        this.itemListFor = [];
        this.mainImagelist = [];
        data.forEach((value, index) => {
          let fomeVaule = {};
          fomeVaule.skuId = data[index].skuId;
          fomeVaule.logo = data[index].logo;
          fomeVaule.price = data[index].jdPrice || data[index].price;
          fomeVaule.title = data[index].wareTitle || data[index].title;
          this.itemListFor.push(fomeVaule);
          this.mainImagelist.push(fomeVaule);
        });
        this.selectGoodsArr = this.itemListFor;
      }
      // console.log(this.selectGoodsArr, this.itemListFor, 3333);
      this.selectGoodsState = false;
    },
    //选中改变
    checkListchange(val) {
      console.log(val);
      console.log(this.levelList);
      val.forEach((low) => {
        if (low == -1) {
          this.ruleForm.partner = ["-1"];
        }
      });
    },
    //生成规则
    generateRule() {
      //活动规则判断
      let oldValue = this.ruleForm;
      let text1 = "",
        text2 = "",
        text3 = "",
        text4 = "",
        text5 = "",
        text6 = "",
        text7 = "",
        text8 = "",
        text9 = "";
      const {firstTextStr,precautions} = this.getCommonText(this.levelList,this.ruleForm,this.ruleDto,this.actMember,false);
      let secondTextStr = "\n二、【如何获奖】\n1.参与方式：在活动有效期内，进入活动手动“邀请好友”参与活动；";
      let thirdTextStr = "三、【活动奖品】";
      let fourthTextStr = `\n\n四、【注意事项】\n1.${ precautions }`
      if (this.activityData.name == "邀请开卡有礼") {
        thirdTextStr = "\n\n三、【活动奖品】";
        thirdTextStr += `\n1.活动奖品：${this.ruleForm.isCumulativePrize==0?"":this.ruleForm.isCumulativePrize==1?"梯度奖品":"任务奖品"}`
        if (this.ruleForm.isCumulativePrize == 0) {
          text6 = "邀请" + this.ruleForm.inviteNum + "人可获得" + this.awardSettingsLsit[0].title + "；";
          if (this.ruleForm.peopleCount) {
            text6 += "活动期间最多邀请" + this.ruleForm.peopleCount + "人;";
          }
        } else if (this.ruleForm.isCumulativePrize == 1) {
          let textArr = this.tableData.map((i,index) => {
            let str = `\n（${index+1}）邀请${i.peopleCount}人可获得${i.title}`;
            return str;
          });
          text6 = textArr.join("，");
        } else {
          let textArr = this.taskTableData.map((i, index) => {
            let str = `\n（${index+1}）任务${this.$toChinesNum(index + 1)}：邀请${i.peopleCount}人可获得${i.title}`;
            return str;
          });
          text6 = textArr.join("，");
        }
        thirdTextStr += text6 + "\n2.领奖说明：需用户点击立即领取才可获奖，超出人数不再获得奖励;\n3.礼品数量有限，先到先得，有可能会有礼品擦肩而过情况；";
        text6 = "";
      }

      // 被邀请人规则
      text7 = "\n2.助力有效规则：";
      if (this.ruleForm.inviteRule == 0) {
        text7 += "被邀请人成功入会;";
      } else {
        text7 += `被邀请人成功入会且有下单，${
          this.ruleForm.inviteRule == 2 ? "下单时间：" : "下单时间要求："
        }`;
        if (this.ruleForm.orderTimeType == 1) {
          text7 += `邀请入会后${this.ruleForm.dayNum}天内${
            this.ruleForm.inviteRule == 2 ? ";" : ";"
          }`;
        } else {
          text7 += `${this.ruleForm.orderStartTime}~${
            this.ruleForm.orderEndTime
          }${this.ruleForm.inviteRule == 2 ? ";" : ";"}`;
        }
      }
      if (this.ruleForm.inviteRule == 2) {
        text7 += `金额统计类型：${
          this.ruleForm.popOrderStartPaymentType == 0 ? "实付金额" : "订单金额"
        };`;
        if (String(this.ruleForm.orderStartPayment) != "") {
          text7 += `订单金额：大于等于${this.ruleForm.orderStartPayment}元；`;
        } else {
          text7 += `订单金额：不限;`;
        }
        if (String(this.ruleForm.itemStartCount) != "") {
          text7 += `商品件数：${this.ruleForm.itemStartCount}件（仅统计时间段内指定商品的订单金额及商品件数）`;
        } else {
          text7 += `商品件数：不限`;
        }
        if (this.ruleForm.skuType == 1) {
          // 指定商品
          text7 += `；指定商品：指定商品（指定商品见活动页）`;
        } else if (this.ruleForm.skuType == 2) {
          // 指定商品
          text7 += `；指定商品：排除商品（排除商品见活动页）`;
        }
      }
      secondTextStr += text7;
      if(this.ruleForm.filterRule == 0) {
        secondTextStr += "\n3.过滤规则：过滤同一活动中被邀请过的人;"
      }else {
        secondTextStr += "\n3.过滤规则：过滤所有活动中被邀请过的人;"
      }
      let levetList = [];
      let levetListOne = [];
      let levetListTwo = "";
      let levetListThree = "";
      this.ruleForm.information.forEach((o, x) => {
        if (o == -1) {
          o = "全部";
        }
        levetListOne.push(o);
      });
      this.itemArrOne.forEach((v, i) => {
        levetList.push(v.informationmationOne);
      });
      levetListTwo = levetListOne.join(",");
      levetListThree = levetList.join(",");
      if (levetListTwo.length != "" && levetListThree.length == 1) {
        levetListThree = "";
      }
      if (levetListTwo.length != "" && levetListThree.length > 1) {
        levetListTwo = levetListOne.join(",") + ",";
      }
      text8 = "";
      text9 =
        "如果被邀请人在邀请过程中开过店铺会员或品牌会员的卡，需要重新回到被邀请人页面，邀请人才能获得奖励！";

      this.ruleForm.activityRulesText = firstTextStr + secondTextStr + thirdTextStr + fourthTextStr;
    },

    // 返回上一步
    clickLocalStep() {
      if (this.backgroundOpacity) {
        this.$emit("returnBack");
        return;
      }
      if (!this.activityData.isCopy && this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      if (this.activityData.isCopy) {
        this.localStep = 0;
        return;
      }
      this.localStep = 0;
      this.localStepNum = 0;
      this.$emit("titopName", this.activityData.name, false);
    },
    checkputnCount(e, row) {
      if (row.quantityTotal && row.price && row.prizeCount) {
        let numTotal = this.$jingdouTotal(row);
        if (!numTotal) {
          this.$message.warning("京豆总份额数量不能大于该京豆预算额！");
        }
        return numTotal;
      } else {
        return row.prizeCount;
      }
    },
    // 品牌定制弹窗
    handleOpen() {
      const href =
        "tencent://message/?uin=800152084&Site=%E5%9C%A8%E7%BA%BF%E5%AE%A2%E6%9C%8D&Menu=yes";
      window.open(href, "_self");
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.titleBox){
  margin: 16px 0;
}
.add_btn1 {
  cursor: pointer;
  color: #fe4d45;
  border: 1px solid #fe4d45;
  width: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  margin-top: 8px;
}
.startTime {
  /deep/ .el-table__body-wrapper {
    padding-left: 30px !important;
  }
}
.prosi {
  position: absolute;
  bottom: 8px;
  right: 30px;
}
.flex {
  display: flex;
  align-items: center;
}
.prize_box {
  padding: 26px 21px;
  background: #fcfcfc;
  .tips {
    width: 600px;
    display: flex;
    align-items: center;
    // align-items: flex-start;
    box-sizing: border-box;
    background: #fffaee;
    border-radius: 3px;
    font-size: 14px;
    font-weight: 400;
    color: #333;
    margin-bottom: 9px;
  }
  .tips_task {
    width: 600px;
    box-sizing: border-box;
    background: #fffaee;
    border-radius: 3px;
    font-size: 14px;
    font-weight: 400;
    color: #333;
    margin-bottom: 9px;

    p {
      padding-left: 20px;
      padding-bottom: 6px;
      line-height: 20px;
    }
  }
  .add_btn {
    cursor: pointer;
    color: #7f85e9;
    border: 1px dashed #7f85e9;
    width: 625px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 8px;
  }
}
.line {
  display: flex;
  align-items: center;
}
.createPlayStep {
  position: relative;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 6px;
  height: 100%;
  // margin: 11px 20px;
  .headReturn {
    box-sizing: border-box;
    padding-left: 30px;
    width: 100%;
    height: 50px;
    line-height: 49px;
    border-bottom: 1px solid #f3f3f3;
    span {
      color: #ccc;
      cursor: pointer;
    }
    .name {
      color: #333;
      cursor: default;
    }
  }
  .step {
    padding: 30px 24px 0;
    .bz {
      display: flex;
      justify-content: center;
      height: 18px;
      // border-bottom: 1px solid #f3f3f3;
      margin-left: 11%;
    }
  }
  .firststep {
    min-height: 820px;
    box-sizing: border-box;
    padding: 35px 35px 0;
    .itemList {
      display: flex;
      .item {
        box-sizing: border-box;
        position: relative;
        color: #666;
        text-align: center;
        padding: 6px;
        &:hover {
          .border::before,
          .border::after {
            opacity: 1;
            transform: scale(1);
          }
        }
        .border {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          border-radius: 4px;
          &::before,
          &::after {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            content: "";
            opacity: 0;
            pointer-events: none;
            transition: opacity 0.8s, transform 0.8s;
            border-radius: 4px;
          }
          &::before {
            border-top: 1px solid #fe4d45;
            border-bottom: 1px solid #fe4d45;
            -webkit-transform: scale(0, 1);
            transform: scale(0, 1);
          }
          &::after {
            border-right: 1px solid #fe4d45;
            border-left: 1px solid #fe4d45;
            -webkit-transform: scale(1, 0);
            transform: scale(1, 0);
          }
        }
        .wrapper {
          position: relative;
          height: 350px;
          border-radius: 6px;
          overflow: hidden;
          .queryId {
            display: none;
          }
          &:hover {
            .queryId {
              display: block;
            }
            .mask {
              opacity: 1;
            }
          }
          .mask {
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.6);
            color: #fff;
            opacity: 0;
            transition: all 0.2s;
            .img {
              max-width: 130px;
              margin: 0 auto 30px;
              .imgBg {
                box-sizing: border-box;
                height: 129px;
                width: 129px;
                padding: 6px;
                border-radius: 6px;
                background-color: #fff;
              }
              .tpl {
                display: inline-block;
                margin-top: 10px;
                color: #fff;
                // opacity: 0.7;
              }
            }
          }
        }
      }
    }
  }
  .secondstep {
    min-height: 870px;
    box-sizing: border-box;
    position: relative;
    padding: 0px 28px 1px 24px;
    margin-bottom: 29px;
    .time2 {
      width: 54px;
      height: 28px;
      border-radius: 4px;
      display: inline-block;
      text-align: center;
      line-height: 28px;
    }
    .generate {
      width: 76px;
      margin: 8px 8px 0 0;
    }
    .lastTime {
      margin-left: 20px;
      font-size: 14px;
      i {
        color: #ccc;
      }
    }
    .theLag {
      position: relative;
      margin-top: 10px;
      width: 280px;
      height: 120px;
      .theBox {
        height: 120px;
        width: 280px;
        // border: 1px solid #999;
        background: url("https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/yhq.png");
        border-radius: 8px;
        position: absolute;
        color: #333333;
        .price_sty {
          // font-family: DIN;
          font-family: PingFang SC;
          font-weight: bold;
          color: #fe4d45;
          font-size: 45px;
        }
        .pp {
          width: 280px;
          text-align: center;
          bottom: 0px;
        }
      }
      //   .btnQx {
      //     display: none;
      //   }
      //   &:hover {
      //     .btnQx {
      //       display: block;
      //       position: absolute;
      //       top: 50%;
      //       left: 50%;
      //       margin: -16px 0 0 -49px;
      //     }
      //     .backgrd {
      //       width: 280px;
      //       height: 120px;
      //       background: #fff;
      //       position: absolute;
      //       border-radius: 8px;
      //       opacity: 0.7;
      //     }
      //   }
    }

    .productImg {
      margin-top: 10px;
      background-color: #fafafa;
      min-height: 80px;
      width: 800px;
      border-radius: 5px;
    }
    .desc {
      i {
        opacity: 0.7;
        color: #fe4d45;
      }
      color: #999;
    }
    .rule-tip {
      width: 540px;
      margin-top: 8px;
      margin-left: 7px;
    }
    .act-tip {
      white-space: nowrap;
      color: #ff0000;
    }
  }
}
.wrapper-kaika {
  width: 100%;
  height: 100%;
  display: grid;
  // align-items: center;
  // justify-content: center;

  &-img {
    background-color: #fafafa;
    border: 2px solid rgba(254, 77, 69, 0.0784313725490196);
    border-radius: 8px;
    height: 350px;
    // margin-right: 20px;
    position: relative;
    &:hover {
      .borderkaika::before,
      .borderkaika::after {
        opacity: 1;
        transform: scale(1);
      }
    }
    .borderkaika {
      position: absolute;
      left: -6px;
      top: -6px;
      width: 218px;
      height: 360px;
      border-radius: 4px;
      &::before,
      &::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        content: "";
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.8s, transform 0.8s;
        border-radius: 4px;
      }
      &::before {
        border-top: 1px solid #fe4d45;
        border-bottom: 1px solid #fe4d45;
        -webkit-transform: scale(0, 1);
        transform: scale(0, 1);
      }
      &::after {
        border-right: 1px solid #fe4d45;
        border-left: 1px solid #fe4d45;
        -webkit-transform: scale(1, 0);
        transform: scale(1, 0);
      }
    }

    div {
      font-size: 18px;
      font-weight: bold;
      // line-height: 25px;
      color: #333333;
    }
    img {
      width: 32px;
      height: 32px;
    }

    .queryIdIMG {
      display: none;
    }
    &:hover {
      .queryIdIMG {
        display: block;
      }
      .mask {
        opacity: 1;
      }
    }
    .mask {
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.6);
      color: #fff;
      opacity: 0;
      transition: all 0.2s;
      .img {
        max-width: 130px;
        margin: 0 auto 30px;
        .imgBg {
          box-sizing: border-box;
          height: 129px;
          width: 129px;
          padding: 6px;
          border-radius: 6px;
          background-color: #fff;
        }
        .tpl {
          display: inline-block;
          font-size: 14px;
          color: #fff;
          margin-top: 10px;
          // opacity: 0.7;
        }
      }
    }
  }
  &-tanchuang {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .lijijq {
    &::after {
      content: "立即领取";
      display: block;
      position: absolute;
      bottom: 9px;
      left: 51%;
      transform: translateX(-50%);
      font-size: 14px;
      // font-family: system-ui;
      font-family: PingFang SC;
      font-weight: bold;
      color: #ed6e09;
      text-shadow: 0 0 black;
    }
  }
}
.radio-width-100 {
  width: 100%;
  .el-radio-group {
    width: 100% !important;
  }
}
</style>

<style lang="scss">
.createPlayStep {
  .textarea {
    .el-textarea__inner {
      min-height: 120px !important;
    }
  }
  .el-step__main {
    position: absolute;
    top: -7px;
    left: 33px;
  }
  .el-step__head.is-process {
    position: absolute;
  }
  .el-step.is-horizontal .el-step__line {
    left: 107px;
    right: 15px;
  }
  .el-step {
    position: relative;
  }
}
.miniAppPic {
  position: relative;
  .image-slot {
    width: 100%;
    height: 100%;
    background: #f5f7fa;
    text-align: center;
    padding-top: 43px;
    i {
      font-size: 30px;
      color: #909399;
    }
  }
  .top {
    position: relative;
    left: 8px;
    display: flex;
    .returnBtn {
      border-radius: 4px;
      width: auto;
      height: 32px;
      line-height: 32px;
      text-align: center;
      color: #fe4d45;
      border: 1px solid #fe4d45;
      &:hover {
        color: #fff;
        background: #fe4d45;
      }
    }
    .reset {
      color: #fe4d45;
      cursor: pointer;
      font-size: 14px;
      margin-left: 15px;
    }
  }
  .bottoms {
    position: relative;
    top: 15px;
    margin-left: 128px;
    .elImg {
      width: 120px;
      height: 120px;
      border: 1px dashed #dddddd;
      border-radius: 5px;
    }
    .tips1 {
      position: absolute;
      left: 135px;
      top: 22px;
      line-height: 2;
      color: #aaaaaa;
      font-size: 13px;
    }
  }
}
.rule_box {
  width: fit-content;
  height: fit-content;
  padding: 10px;
  background: #fafafa;
  border-radius: 4px;
  font-size: 14px;
  margin-top: 20px;
  &_top {
    margin: 15px 0 10px 15px;
  }
  &_middle {
    margin-left: 10px;
    .middle-box {
      display: flex;
      align-items: center;
      &_tip {
        color: #ff0000;
      }
    }
  }
  &_bottom {
    margin-left: 7px;
  }
}
</style>
